/** Arabic for decisions and intelligence: the Decision Room, the engine, the intelligence report, D-Brief and What if. Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  "The arithmetic is separated from the argument. Every number here is computed from a platform record or a value a named person entered, with its working beside it. A connected model only explains those numbers and is checked against them; it never produces one.":
    "الحساب منفصل عن الحجة. كل رقم هنا محسوب من سجل على المنصة أو من قيمة أدخلها شخص مسمّى، وبجانبه طريقة حسابه. النموذج المتصل يشرح هذه الأرقام فقط ويُتحقَّق منه مقابلها؛ ولا يُنتج رقمًا أبدًا.",
  "saved on the platform, under your name": "حُفظ على المنصة باسمك",
  "decision logged on the platform under {name}": "سُجّل القرار على المنصة باسم {name}",
  "decision kept in this browser only — the platform did not take the note":
    "حُفظ القرار في هذا المتصفح فقط — لم تقبل المنصة الملاحظة",
  "The quarter — {quarter}": "الربع — {quarter}",
  "Night windows": "النوافذ الليلية",
  Crews: "الطواقم",
  "Nights per crew": "الليالي لكل طاقم",
  "e.g. Pavements": "مثل: الرصف",
  "e.g. winter": "مثل: الشتاء",
  "weight {name}": "وزن {name}",
  "Save the quarter": "حفظ الربع",
  "{n} mandatory — below a limit, so removed from the trade-off and done first":
    "{n} إلزامي — دون الحد، لذا أُخرج من المفاضلة ويُنفَّذ أولًا",
  "Nothing on the platform is past a limit.": "لا شيء على المنصة تجاوز حدًّا.",
  "Nothing discretionary on the platform.": "لا بنود اختيارية على المنصة.",
  "no source": "بلا مصدر",
  "not a decision": "ليس قرارًا",
  "Mandatory: {why}. It is done first; the solver subtracts its window, crew and cost before allocating anything else.":
    "إلزامي: {why}. يُنفَّذ أولًا؛ وتخصم أداة الحل نافذته وطاقمه وتكلفته قبل تخصيص أي شيء آخر.",
  Condition: "الحالة الفنية",
  "Time to threshold": "الوقت حتى الحد",
  Clause: "البند",
  "none on the rule": "لا يوجد في القاعدة",
  "{n} min closure": "إغلاق {n} دقيقة",
  "closure minutes unknown": "دقائق الإغلاق غير معروفة",
  "{n} movements/h": "{n} حركة/ساعة",
  "movements unknown": "الحركات غير معروفة",
  "Cost curve": "منحنى التكلفة",
  "{now} now · {quarter} next quarter · {year} in a year · {twoYears} in two":
    "{now} الآن · {quarter} الربع القادم · {year} خلال سنة · {twoYears} خلال سنتين",
  "night window": "نافذة ليلية",
  "no night window": "بلا نافذة ليلية",
  "no crew": "بلا طاقم",
  "exposure after": "التعرّض بعده",
  displaces: "يُزيح",
  "Missing on the platform — enter it, under your name, and it enters the engine as an entered source":
    "ناقص على المنصة — أدخله باسمك، فيدخل المحرك بوصفه مصدرًا مُدخلًا",
  "e.g. two surveys, Mar and Aug": "مثل: مسحان، مارس وأغسطس",
  "as the engine assumed": "كما افترض المحرك",
  "Enter these": "أدخِل هذه القيم",
  "Logged. It is on the decision log below, with the evidence that was on screen.":
    "سُجّل. تجده في سجل القرارات أدناه، مع الأدلة التي كانت على الشاشة.",
  "Log the decision — what was chosen, by whom, on what evidence, with what mitigation":
    "سجّل القرار — ما الذي اختير، ومن اختاره، وعلى أي أدلة، وبأي إجراء تخفيف",
  "decision for {name}": "القرار بشأن {name}",
  "why this, in a sentence a regulator will read": "لماذا هذا، في جملة ستقرؤها الجهة التنظيمية",
  "rationale for {name}": "مبرر {name}",
  "Log this decision": "سجّل هذا القرار",
  "{quarter}: what fits, what slips, and what each slip costs": "{quarter}: ما يتسع، وما يتأجل، وكم يكلّف كل تأجيل",
  windows: "النوافذ",
  "crew-nights": "ليالي الطواقم",
  objective: "دالة الهدف",
  "Mandatory first": "الإلزامي أولًا",
  Chosen: "المختار",
  "Slipped, and what it costs": "المؤجَّل، وكم يكلّف",
  "The model's explanation was withheld: it stated a figure the engine did not produce ({figures}). The engine's own case stands.":
    "حُجب شرح النموذج: ذكر رقمًا لم يُنتجه المحرك ({figures}). تبقى حجة المحرك نفسه قائمة.",
  "The model's explanation was withheld: it stated figures the engine did not produce ({figures}). The engine's own case stands.":
    "حُجب شرح النموذج: ذكر أرقامًا لم يُنتجها المحرك ({figures}). تبقى حجة المحرك نفسه قائمة.",
  "Explained by {model}; every figure checked against the engine's output.":
    "شرحه {model}؛ وكل رقم تُحقِّق منه مقابل مخرجات المحرك.",
  "the engine": "المحرك",
  // prettier-ignore
  "The engine answers questions about an item, a component, the slipped set, the mandatory set, or a changed constraint (\"what if we had 10 windows\"). Connect a model in Settings for anything wider.": "يجيب المحرك عن أسئلة حول بند، أو مكوّن، أو المجموعة المؤجلة، أو المجموعة الإلزامية، أو قيد متغيّر (\"what if we had 10 windows\"). اربط نموذجًا من الإعدادات لأي شيء أوسع.",
  "Withheld: the reply stated figures the engine did not produce ({figures}).":
    "محجوب: ذكر الرد أرقامًا لم يُنتجها المحرك ({figures}).",
  "Reasoning chain": "سلسلة الاستدلال",
  "The strongest counter-argument": "أقوى حجة مضادة",
  "What would change the answer": "ما الذي يغيّر الإجابة",
  "Ask the model to explain and challenge": "اطلب من النموذج الشرح والاعتراض",
  "Why is RWY-17-35 above the bridge? What if we had 10 windows? What slips?":
    "Why is RWY-17-35 above the bridge? What if we had 10 windows? What slips?",
  "Follow-up question": "سؤال متابعة",
  "edited by {name} on {date}": "عدّلها {name} في {date}",
  "Hide the card": "إخفاء البطاقة",
  "Edit the card": "تعديل البطاقة",
  "Save the card": "حفظ البطاقة",
  "Unit repair now ({currency})": "تكلفة الإصلاح الآن للوحدة ({currency})",
  "Escalation per quarter": "التصاعد لكل ربع",
  "Mitigation cost": "تكلفة التخفيف",
  Mitigation: "إجراء التخفيف",
  "{category} unit repair": "إصلاح وحدة {category}",
  "Zone class": "فئة المنطقة",
  "Cost per closure hour ({currency})": "التكلفة لكل ساعة إغلاق ({currency})",
  "Movements per hour (when the capacity model has no coverage)": "الحركات في الساعة (حين لا يغطي نموذج السعة)",
  " — mitigation: {mitigation}": " — التخفيف: {mitigation}",
  " — threshold in {n} days at the time": " — الحد بعد {n} يومًا وقتها",
  "score {score} on {coverage}": "الدرجة {score} على {coverage}",
  "{n} crew-night|{n} crew-nights":
    "لا ليالي طواقم|ليلة طاقم واحدة|ليلتا طاقم|{n} ليالي طواقم|{n} ليلة طاقم|{n} ليلة طاقم",
  "The engine": "المحرك",
  "Print for the board": "طباعة لمجلس الإدارة",
  "The decisions the platform's own records put on your desk, each framed the same way: the stakes, the options side by side, what each survives, and what would change the answer. Every figure is a record, a rate the airport entered, or a value a named person typed, and it says which.":
    "القرارات التي تضعها سجلات المنصة نفسها على مكتبك، كلٌّ منها مؤطَّر بالطريقة نفسها: ما على المحك، والخيارات جنبًا إلى جنب، وما يصمد أمامه كلٌّ منها، وما الذي يغيّر الإجابة. كل رقم هو سجل، أو سعر أدخله المطار، أو قيمة كتبها شخص مسمّى، ويذكر أيّها.",
  "Which option is robust?": "أي خيار هو الأمتن؟",
  "What would change the answer?": "ما الذي يغيّر الإجابة؟",
  "The case against": "الحجة المضادة",
  "decision recorded on the platform under {name}": "سُجّل القرار على المنصة باسم {name}",
  "The desk in numbers": "المكتب بالأرقام",
  "decisions on the desk": "قرارات على المكتب",
  "days to the nearest decide-by": "أيام حتى أقرب موعد للقرار",
  "cash in the recommended options": "النقد في الخيارات الموصى بها",
  "closure hours priced separately": "ساعات الإغلاق مسعّرة على حدة",
  "decisions recorded": "قرارات مسجّلة",
  "latest {date} by {name}": "آخرها {date} بواسطة {name}",
  "none yet": "لا شيء بعد",
  "The desk": "المكتب",
  "Assumptions — the dates, the quarter and the rate card every figure above rests on":
    "الافتراضات — التواريخ والربع وبطاقة الأسعار التي يستند إليها كل رقم أعلاه",
  decided: "تقرّر",
  "decide in {n} days": "القرار خلال {n} يومًا",
  robust: "متين",
  "not the robust choice": "ليس الخيار الأمتن",
  "no option priced yet": "لا خيار مسعّر بعد",
  "decide by {date}": "القرار قبل {date}",
  "On the desk because": "على المكتب لأن",
  "Door:": "الباب:",
  "one-way": "باتجاه واحد",
  "two-way": "باتجاهين",
  "The stakes": "ما على المحك",
  "rate card / entered": "بطاقة الأسعار / مُدخل",
  "The options": "الخيارات",
  "Against it:": "ضده:",
  "No flip point: the recommendation holds across every sweep the room tried, or no second option is priced.":
    "لا نقطة انقلاب: التوصية صامدة عبر كل المسوح التي جرّبتها الغرفة، أو لا يوجد خيار ثانٍ مسعّر.",
  "{input} is {now}; {at}, {outcome}.": "{input} هو {now}؛ {at}، {outcome}.",
  option: "الخيار",
  "{n} h closed": "{n} ساعة إغلاق",
  "closure unknown": "الإغلاق غير معروف",
  "exposure {n}": "التعرّض {n}",
  For: "مع",
  Against: "ضد",
  Displaces: "يُزيح",
  "estimate ({currency})": "التقدير ({currency})",
  "estimated cost of {name}": "التكلفة التقديرية لـ {name}",
  "Enter the estimate": "أدخِل التقدير",
  "The model's challenge was withheld: it stated a figure the room did not produce ({figures}).":
    "حُجب اعتراض النموذج: ذكر رقمًا لم تُنتجه الغرفة ({figures}).",
  "The model's challenge was withheld: it stated figures the room did not produce ({figures}).":
    "حُجب اعتراض النموذج: ذكر أرقامًا لم تُنتجها الغرفة ({figures}).",
  "Challenged by {model}; every figure checked against the room.":
    "اعترض عليه {model}؛ وكل رقم تُحقِّق منه مقابل الغرفة.",
  "the room": "الغرفة",
  "The room answers questions about an option, the recommendation, the case against it, what is robust, what would flip the answer, what is displaced, and the board line. Connect a model in Settings for anything wider.":
    "تجيب الغرفة عن أسئلة حول خيار، أو التوصية، أو الحجة المضادة لها، أو الخيار الأمتن، أو ما يقلب الإجابة، أو ما يُزاح، أو سطر مجلس الإدارة. اربط نموذجًا من الإعدادات لأي شيء أوسع.",
  "Withheld: the reply stated figures the room did not produce ({figures}).":
    "محجوب: ذكر الرد أرقامًا لم تُنتجها الغرفة ({figures}).",
  "Which option is robust? What would change the answer? What does the bundle displace?":
    "Which option is robust? What would change the answer? What does the bundle displace?",
  "Question for the room": "سؤال للغرفة",
  "decision on {name}": "القرار في {name}",
  "why this, and what was accepted to get it": "لماذا هذا، وما الذي قُبل للوصول إليه",
  "Record the decision": "سجّل القرار",
  "{n}, latest first — each a dated, attributed note on the platform":
    "{n}، الأحدث أولًا — كلٌّ منها ملاحظة مؤرّخة ومنسوبة على المنصة",
  "Ramadan, Hajj, summer": "رمضان، الحج، الصيف",
  "peak name": "اسم الذروة",
  "peak start date": "تاريخ بدء الذروة",
  "Save the dates": "حفظ التواريخ",
  "entered by {name}": "أدخله {name}",
  " on {date}": " في {date}",
  "{n} one-way door|{n} one-way doors":
    "لا قرارات بلا رجعة|قرار واحد بلا رجعة|قراران بلا رجعة|{n} قرارات بلا رجعة|{n} قرارًا بلا رجعة|{n} قرار بلا رجعة",
  "{n} record cited — each opens on the platform|{n} records cited — each opens on the platform":
    "لا سجلات مستشهد بها|سجل واحد مستشهد به — يُفتح على المنصة|سجلان مستشهد بهما — كلٌّ منهما يُفتح على المنصة|{n} سجلات مستشهد بها — كلٌّ منها يُفتح على المنصة|{n} سجلًا مستشهدًا به — كلٌّ منها يُفتح على المنصة|{n} سجل مستشهد به — كلٌّ منها يُفتح على المنصة",
  "generated {date} UTC": "أُنشئ {date} UTC",
  "going to break": "ستتعطل",
  "{n} inside 30 days": "{n} خلال 30 يومًا",
  "broken, still open": "معطّلة وما زالت مفتوحة",
  "already failing or overdue": "متعطلة فعلًا أو متأخرة",
  "priced exposure": "التعرّض المسعّر",
  "{priced} priced · {unpriced} the platform will not price": "{priced} مسعّرة · {unpriced} لن تسعّرها المنصة",
  "with a named party": "بطرف مسمّى",
  "{n} nobody is on record for": "{n} لا أحد مسجّل مسؤولًا عنها",
  "strong / partial / weak": "قوي / جزئي / ضعيف",
  "how far each finding can be defended": "إلى أي حد يمكن الدفاع عن كل ملاحظة",
  "Each row is a prediction, its cost and the party who holds it, from the platform's own records, with the evidence and the weaknesses stated. A blank is never filled in: where the platform cannot price a thing or name a party it says so in the row, because a figure that cannot be defended is worse in front of a regulator than none.":
    "كل صف تنبؤ وتكلفته والطرف المسؤول عنه، من سجلات المنصة نفسها، مع ذكر الأدلة ونقاط الضعف. لا يُملأ فراغ أبدًا: حيث لا تستطيع المنصة تسعير شيء أو تسمية طرف تقول ذلك في الصف، لأن رقمًا لا يمكن الدفاع عنه أسوأ أمام الجهة التنظيمية من عدم وجود رقم.",
  "Prediction.": "التنبؤ.",
  "Predictive alerts come from the platform's rules on its own readings, each with the rule's expression, the parameters it was given and the values that fired it. Wear-out findings come from survival fits on the failure records of a whole population, and are stated as populations, because unit ages are not held. Overdue tests, obligations and work are the platform's own dates.":
    "تأتي التنبيهات التنبؤية من قواعد المنصة على قراءاتها هي، كلٌّ منها مع تعبير القاعدة والمعاملات المعطاة لها والقيم التي أطلقتها. وتأتي ملاحظات الاهتراء من ملاءمات البقاء على سجلات أعطال مجموعة كاملة، وتُذكر بوصفها مجموعات لأن أعمار الوحدات غير محفوظة. والاختبارات والالتزامات والأعمال المتأخرة هي تواريخ المنصة نفسها.",
  "Cost.": "التكلفة.",
  "From the deferred-cost register where a priced candidate names the same asset or zone, else from the cost planned on the work order. The platform does not price a thing it has no rate for, and this report does not either.":
    "من سجل تكلفة التأجيل حيث يسمّي مرشح مسعّر الأصل أو المنطقة نفسها، وإلا فمن التكلفة المخططة على أمر العمل. لا تسعّر المنصة شيئًا ليس لديها سعر له، ولا يفعل هذا التقرير.",
  "Responsibility.": "المسؤولية.",
  "The crew or contractor on the work order the alert raised, else on the open work for the same asset or zone; the later party in a systematic records disagreement; the project at a failed hold point. Where no work has been assigned, no party is named, and that is recorded as a weakness.":
    "الطاقم أو المقاول على أمر العمل الذي أنشأه التنبيه، وإلا فعلى العمل المفتوح للأصل أو المنطقة نفسها؛ والطرف المتأخر في خلاف منهجي بين السجلات؛ والمشروع عند نقطة توقف راسبة. وحيث لم يُسنَد عمل لا يُسمّى طرف، ويُسجَّل ذلك نقطة ضعف.",
  "Defensibility.": "قابلية الدفاع.",
  "Strong: the claim rests on dated platform records and a verified rule or a conclusive model check. Partial: something is missing — an unpriced cost, an unnamed party, a proposed rather than agreed threshold, an inconclusive check. Weak: the rule's threshold is unverified, the model has drifted, or the record is a demonstration. The regulatory references shown are those the rule itself carries.":
    "قوي: يستند الادعاء إلى سجلات منصة مؤرّخة وقاعدة موثّقة أو فحص نموذج حاسم. جزئي: ينقص شيء — تكلفة غير مسعّرة، أو طرف غير مسمّى، أو حد مقترح لا متفق عليه، أو فحص غير حاسم. ضعيف: حد القاعدة غير موثّق، أو انحرف النموذج، أو السجل عرض توضيحي. المراجع التنظيمية المعروضة هي التي تحملها القاعدة نفسها.",
  "severity {n}": "الخطورة {n}",
  "Nobody named": "لا أحد مسمّى",
  alerts: "التنبيهات",
  rules: "القواعد",
  "work orders": "أوامر العمل",
  "testing summary": "ملخص الاختبارات",
  compliance: "الامتثال",
  "deferred-cost register": "سجل تكلفة التأجيل",
  "reliability populations": "مجموعات الموثوقية",
  "drift checks": "فحوص الانحراف",
  "records ledger": "دفتر السجلات",
  "hold points": "نقاط التوقف",
  "explanation of {id}": "شرح {id}",
  "fit for {population}": "الملاءمة لـ {population}",
  "divergence on {fact}": "التباعد في {fact}",
  "as of {date} UTC": "حتى {date} UTC",
  Regenerate: "إعادة الإنشاء",
  "Not another dashboard. Three things that will degrade capacity in the next thirty days, what each costs in closure minutes and remote-stand penalties, and the decision to make this week. Then ask the evidence anything.":
    "ليست لوحة معلومات أخرى. ثلاثة أمور ستُضعف السعة خلال الثلاثين يومًا القادمة، وكم يكلّف كلٌّ منها بدقائق الإغلاق وغرامات المواقف البعيدة، والقرار الواجب اتخاذه هذا الأسبوع. ثم اسأل الأدلة عن أي شيء.",
  "{n} of {findings} weighed": "{n} من {findings} وُزنت",
  "Nothing on the platform touches capacity inside thirty days. See the intelligence report for what it does hold.":
    "لا شيء على المنصة يمس السعة خلال ثلاثين يومًا. راجع التقرير التحليلي لما تحتويه.",
  "Closure minutes": "دقائق الإغلاق",
  "Remote-stand penalty": "غرامة المواقف البعيدة",
  "{n} stranded": "{n} عالقة",
  "Decision this week": "قرار هذا الأسبوع",
  "full finding →": "الملاحظة كاملة ←",
  "{phase} photograph": "صورة {phase}",
  "photo photograph": "صورة",
  "Ask the evidence": "اسأل الأدلة",
  "Looking…": "جارٍ البحث…",
  "The platform's assistant says": "يقول مساعد المنصة",
  "What happened": "ما الذي حدث",
  "What it cost": "كم كلّف",
  Attached: "المرفقات",
  "could not be fetched": "تعذّر الجلب",
  "fetching…": "جارٍ الجلب…",
  "{n} capacity finding|{n} capacity findings":
    "لا ملاحظات سعة|ملاحظة سعة واحدة|ملاحظتا سعة|{n} ملاحظات سعة|{n} ملاحظة سعة|{n} ملاحظة سعة",
  "No baseline program could be built, so there is nothing to vary.":
    "تعذّر بناء برنامج أساسي، لذا لا يوجد ما يمكن تغييره.",
  "Baseline — what today's inputs produce": "الأساس — ما تُنتجه مدخلات اليوم",
  Undecided: "غير محسوم",
  "Every variant below was tested and changed nothing. Money, crews and timing are not what is holding this program back — the facts are. The register beneath is where to look.":
    "اختُبر كل متغير أدناه ولم يغيّر شيئًا. ليس المال ولا الطواقم ولا التوقيت ما يعيق هذا البرنامج — بل الحقائق. السجل أدناه هو حيث يجب البحث.",
  "Variants — {n}": "المتغيرات — {n}",
  "If somebody supplied the missing facts": "لو قدّم أحد الحقائق الناقصة",
  Escalation: "التصاعد",
  "avoids {amount}": "يتجنب {amount}",
  "adds {amount}": "يضيف {amount}",
  "{n} fact|{n} facts": "لا حقائق|حقيقة واحدة|حقيقتان|{n} حقائق|{n} حقيقة|{n} حقيقة",
  "by Thursday {date}": "قبل الخميس {date}",
  "Commission the repair and order the retest — {finding}.": "كلّف بالإصلاح واطلب إعادة الاختبار — {finding}.",
  "Testing owner (unassigned)": "مسؤول الاختبار (غير مُسنَد)",
  "Assign the obligation and file the evidence against it.": "أسنِد الالتزام وقدّم الأدلة عليه.",
  "Compliance owner (unassigned)": "مسؤول الامتثال (غير مُسنَد)",
  "Decide whether the hold point is re-inspected or the project re-sequenced.":
    "قرّر هل يُعاد فحص نقطة التوقف أم يُعاد ترتيب المشروع.",
  "Project owner": "مالك المشروع",
  "Create the work order and name a crew for it.": "أنشئ أمر العمل وسمِّ طاقمًا له.",
  "Maintenance lead (unassigned)": "قائد الصيانة (غير مُسنَد)",
  "Assign a crew to {number} and set its due date.": "أسنِد طاقمًا إلى {number} وحدّد تاريخ استحقاقه.",
  "{discipline} lead": "قائد {discipline}",
  "Maintenance lead": "قائد الصيانة",
  "Escalate {number} or extend its SLA with a recorded reason — it is past due.":
    "صعّد {number} أو مدّد اتفاقية مستوى الخدمة له بسبب مسجّل — لقد تجاوز موعده.",
  "Book the closure window for {number} in When to work, before the forecast date.":
    "احجز نافذة الإغلاق لـ {number} في «متى يُنفَّذ العمل»، قبل التاريخ المتوقع.",
  "Confirm {number} is resourced to complete by its due date.":
    "تأكّد من توفير الموارد لـ {number} لإنجازه بحلول تاريخ استحقاقه.",
  "median of {closures} of {zone} on record": "وسيط {closures} لـ {zone} في السجل",
  "labour hours planned on {number}": "ساعات العمل المخططة على {number}",
  "no closure of {zone} on record and no labour hours planned — not estimated":
    "لا إغلاق لـ {zone} في السجل ولا ساعات عمل مخططة — غير مقدَّر",
  "no zone on the finding — not estimated": "لا منطقة على الملاحظة — غير مقدَّر",
  "{movements} in a {minutes}-minute closure tomorrow at the usual hour: {absorbed} absorbed, {bussed} bussed to remote stands, {stranded} stranded{assumption}":
    "{movements} في إغلاق مدته {minutes} دقيقة غدًا في الساعة المعتادة: {absorbed} استُوعبت، و{bussed} نُقلت بالحافلات إلى مواقف بعيدة، و{stranded} عالقة{assumption}",
  "the capacity model prices stand and gate closures; {zone} is not a stand, so its remote-stand penalty is not modeled — the closure minutes are the cost the platform can state":
    "يسعّر نموذج السعة إغلاقات المواقف والبوابات؛ و{zone} ليس موقفًا، لذا لا تُنمذج غرامة المواقف البعيدة له — دقائق الإغلاق هي التكلفة التي تستطيع المنصة ذكرها",
  "the capacity model could not price it: {why}": "تعذّر على نموذج السعة تسعيره: {why}",
  "no schedule coverage": "لا تغطية في جدول الرحلات",
  "not priced — no capacity model answer for the zone": "غير مسعّر — لا إجابة من نموذج السعة للمنطقة",
  "not priced — no zone on the finding": "غير مسعّر — لا منطقة على الملاحظة",
  "already happening on the platform's own record": "يحدث فعلًا وفق سجل المنصة نفسها",
  "the rule's own confidence is {pct}%; {grade} on the evidence": "ثقة القاعدة نفسها {pct}%؛ {grade} وفق الأدلة",
  "{grade} on the evidence: {detail}": "{grade} وفق الأدلة: {detail}",
  "see the intelligence report": "راجع التقرير التحليلي",
  "Only {findings} on the platform touch capacity inside thirty days; the brief does not pad the list.":
    "فقط {findings} على المنصة تمس السعة خلال ثلاثين يومًا؛ ولا يحشو الموجز القائمة.",
  "A closure-minutes cell left blank means the zone has no closure history and no labour hours planned; the platform does not guess.":
    "خانة دقائق الإغلاق الفارغة تعني أن المنطقة بلا تاريخ إغلاق ولا ساعات عمل مخططة؛ والمنصة لا تخمّن.",
  "A remote-stand cell left blank means the capacity model had no schedule coverage for the window.":
    "خانة المواقف البعيدة الفارغة تعني أن نموذج السعة لم تكن لديه تغطية جدول للنافذة.",
  yesterday: "أمس",
  "the last seven days": "الأيام السبعة الأخيرة",
  "the last thirty days": "الأيام الثلاثين الأخيرة",
  "No runway, taxiway, stand or apron in the question that the records could be searched for.":
    "لا يذكر السؤال مدرجًا أو ممر طائرات أو موقف طائرة أو ساحة وقوف يمكن البحث عنها في السجلات.",
  "No closure of {zone} is on record at all.": "لا يوجد أي إغلاق لـ {zone} في السجل.",
  "{from} to {to}": "من {from} إلى {to}",
  "No closure of {zone} is on record for {when}. The most recent was {day}: {reason} ({minutes} min).":
    "لا إغلاق لـ {zone} في السجل لـ {when}. آخرها كان {day}: {reason} ({minutes} دقيقة).",
  "the most recent day it was closed, {day}": "آخر يوم أُغلق فيه، {day}",
  "{zone} was closed {times} on {day}, {total} in all{planned}.":
    "أُغلق {zone} {times} في {day}، {total} إجمالًا{planned}.",
  once: "مرة واحدة",
  "{n} times": "{n} مرات",
  " ({minutes} of it planned)": " ({minutes} منها مخطط)",
  "{kind} {extent} closure {from}–{to}{minutes}: {reason}{chainage}.":
    "إغلاق {kind} {extent} {from}–{to}{minutes}: {reason}{chainage}.",
  Unplanned: "غير مخطط",
  "You said {claimed}; the record says {recorded}.": "قلتَ {claimed}؛ والسجل يقول {recorded}.",
  "{kind} {extent} closure of {zone}": "إغلاق {kind} {extent} لـ {zone}",
  ", {discipline} discipline": "، تخصص {discipline}",
  ", completed {date}": "، اكتمل {date}",
  ", cost {amount}": "، التكلفة {amount}",
  "Inspection {name} completed {date}: score {score}, {failed}.":
    "الفحص {name} اكتمل {date}: الدرجة {score}، {failed}.",
  "{date} · {failed} failed · {answered} answered": "{date} · {failed} راسبة · {answered} مُجابة",
  // prettier-ignore
  "Rule \"{rule}\" fired {date}: {title}{ref}.": "القاعدة \"{rule}\" انطلقت {date}: {title}{ref}.",
  "severity {severity} · {date}": "الخطورة {severity} · {date}",
  // prettier-ignore
  "Clause behind \"{rule}\"": "البند وراء \"{rule}\"",
  "The closure records give the reason above; no work order, inspection or rule on the platform is tied to {zone} around that day.":
    "تذكر سجلات الإغلاق السبب أعلاه؛ ولا يرتبط أي أمر عمل أو فحص أو قاعدة على المنصة بـ {zone} حول ذلك اليوم.",
  "The closure records give the reasons above; no work order, inspection or rule on the platform is tied to {zone} around that day.":
    "تذكر سجلات الإغلاق الأسباب أعلاه؛ ولا يرتبط أي أمر عمل أو فحص أو قاعدة على المنصة بـ {zone} حول ذلك اليوم.",
  "{total} of closure{planned}.": "{total} من الإغلاق{planned}.",
  ", {minutes} planned": "، {minutes} مخطط",
  "{amount} actual cost on the work order.": "{amount} تكلفة فعلية على أمر العمل.",
  "{amount} actual cost on the work orders.": "{amount} تكلفة فعلية على أوامر العمل.",
  "{zone}, {day}: {total} closed": "{zone}، {day}: {total} إغلاق",
  "The capacity model did not answer for that window.": "لم يُجب نموذج السعة عن تلك النافذة.",
  "The capacity model could not price the window: {why}.": "تعذّر على نموذج السعة تسعير النافذة: {why}.",
  "{movements} fell in the window: {absorbed} absorbed elsewhere, {bussed} bussed to remote stands, {stranded} stranded{undetermined}.":
    "{movements} ضمن النافذة: {absorbed} استُوعبت في مكان آخر، و{bussed} نُقلت بالحافلات إلى مواقف بعيدة، و{stranded} عالقة{undetermined}.",
  ", {n} undetermined": "، و{n} غير محددة",
  "Remote-stand penalty: {bussed}{assumption}.": "غرامة المواقف البعيدة: {bussed}{assumption}.",
  "{n} closure|{n} closures": "لا إغلاقات|إغلاق واحد|إغلاقان|{n} إغلاقات|{n} إغلاقًا|{n} إغلاق",
  "{n} bussed movement|{n} bussed movements":
    "لا حركات منقولة بالحافلات|حركة واحدة منقولة بالحافلات|حركتان منقولتان بالحافلات|{n} حركات منقولة بالحافلات|{n} حركة منقولة بالحافلات|{n} حركة منقولة بالحافلات",
  "{what} entered by {name}": "{what} أدخله {name}",
  "{what} entered": "{what} مُدخل",
  "rate card (edited by {name})": "بطاقة الأسعار (عدّلها {name})",
  "rate card (starting card, unedited)": "بطاقة الأسعار (البطاقة الابتدائية، دون تعديل)",
  "no measured condition on record": "لا حالة مقيسة في السجل",
  "{value} against minimum {limit}": "{value} مقابل حد أدنى {limit}",
  "{value} against maximum {limit}": "{value} مقابل حد أقصى {limit}",
  "{value} against {limit} (entered)": "{value} مقابل {limit} (مُدخل)",
  "no reading against a limit on record; enter the measured value and the limit":
    "لا قراءة مقابل حد في السجل؛ أدخل القيمة المقيسة والحد",
  "not computable: no condition history": "غير قابل للحساب: لا تاريخ للحالة",
  "{n} readings over {days} days, least-squares slope {rate} per day":
    "{n} قراءات على مدى {days} يومًا، ميل المربعات الصغرى {rate} يوميًا",
  "not computable: readings on one day": "غير قابل للحساب: القراءات في يوم واحد",
  "{value} on {date}": "{value} في {date}",
  " against {limit}": " مقابل {limit}",
  "entered, not measured": "مُدخل، غير مقيس",
  "the rule's own forecast: {forecast}": "توقع القاعدة نفسها: {forecast}",
  "no condition history to fit a trend; enter the rate of change per day and where it comes from":
    "لا تاريخ للحالة لملاءمة اتجاه؛ أدخل معدل التغير اليومي ومصدره",
  "{basis}; the trend runs away from the limit, so no threshold date":
    "{basis}؛ يبتعد الاتجاه عن الحد، لذا لا تاريخ لبلوغه",
  "already at the limit: the finding is open on the platform now": "عند الحد فعلًا: الملاحظة مفتوحة على المنصة الآن",
  "no clause on the rule": "لا بند في القاعدة",
  "{n} labour hours planned": "{n} ساعة عمل مخططة",
  "no closure of this zone on record and no labour hours planned; enter the closure the work needs":
    "لا إغلاق لهذه المنطقة في السجل ولا ساعات عمل مخططة؛ أدخل الإغلاق الذي يحتاجه العمل",
  "{movements} movements in {hours} h from the capacity model": "{movements} حركة في {hours} ساعة من نموذج السعة",
  "no capacity model coverage and no movements figure on the card for this kind of zone":
    "لا تغطية من نموذج السعة ولا رقم للحركات على البطاقة لهذا النوع من المناطق",
  "actual cost on the work order": "التكلفة الفعلية على أمر العمل",
  "planned cost on the work order": "التكلفة المخططة على أمر العمل",
  "priced from the starting rate card ({amount} for {category}); enter this job's own estimate":
    "مسعّر من بطاقة الأسعار الابتدائية ({amount} لفئة {category})؛ أدخل تقدير هذه المهمة نفسها",
  "{crew} on the work order": "{crew} على أمر العمل",
  "no crew or discipline on any work for this; enter who does it and how many nights it takes":
    "لا طاقم ولا تخصص على أي عمل لهذا؛ أدخل من ينفّذه وكم ليلة يستغرق",
  "a severity-5 rule with a {framework} limit fired on the platform's readings":
    "انطلقت قاعدة بخطورة 5 ذات حد من {framework} على قراءات المنصة",
  "the last mandatory test failed against its threshold": "رسب آخر اختبار إلزامي مقابل حده",
  "the obligation is overdue": "الالتزام متأخر",
  "the certificate has expired": "انتهت صلاحية الشهادة",
  "the measured condition is past the {framework} limit": "الحالة المقيسة تجاوزت حد {framework}",
  Consequence: "العاقبة",
  "{minutes} min ÷ 60 × {movements} movements/h × {factor} ({zone}) ÷ 200 = {value}":
    "{minutes} دقيقة ÷ 60 × {movements} حركة/ساعة × {factor} ({zone}) ÷ 200 = {value}",
  "not computable: closure minutes or movements per hour missing":
    "غير قابل للحساب: دقائق الإغلاق أو الحركات في الساعة ناقصة",
  "{days} days to the limit; 1 − {days}/180 = {value} — {basis}":
    "{days} يومًا حتى الحد؛ 1 − {days}/180 = {value} — {basis}",
  "not computable — {basis}": "غير قابل للحساب — {basis}",
  "Regulatory exposure": "التعرّض التنظيمي",
  "not scored: the limit is crossed, so this is mandatory action, not a trade-off":
    "بلا درجة: تجاوز الحد، لذا هذا إجراء إلزامي لا مفاضلة",
  "distance to the limit {distance} × effect {effect} ({clause}) = {value}":
    "المسافة إلى الحد {distance} × الأثر {effect} ({clause}) = {value}",
  "no measured distance to the limit; the clause's effect alone ({effect}) at half weight = {value}":
    "لا مسافة مقيسة إلى الحد؛ أثر البند وحده ({effect}) بنصف الوزن = {value}",
  "not computable: no clause on the rule and no limit on record": "غير قابل للحساب: لا بند في القاعدة ولا حد في السجل",
  "Deferral cost curve": "منحنى تكلفة التأجيل",
  "{now} today → {year} in a year; (year − now) ÷ now = {value}":
    "{now} اليوم ← {year} خلال سنة؛ (السنة − الآن) ÷ الآن = {value}",
  "Window constraint": "قيد النافذة",
  "needs a night window; {free} of {windows} free → {scarcity}":
    "يحتاج نافذة ليلية؛ {free} من {windows} متاحة ← {scarcity}",
  "no night window needed → 0": "لا حاجة إلى نافذة ليلية ← 0",
  " + scarce crew {penalty}": " + طاقم نادر {penalty}",
  " + out of season {penalty}": " + خارج الموسم {penalty}",
  "{n} of 5 components": "{n} من 5 مكوّنات",
  "Act now": "التنفيذ الآن",
  "{cost} now{closure}; the exposure is retired.": "{cost} الآن{closure}؛ ويزول التعرّض.",
  ", {n} min of closure this quarter": "، {n} دقيقة إغلاق هذا الربع",
  "Defer with mitigation": "التأجيل مع التخفيف",
  "{mitigation}; {cost}; exposure halved while the mitigation holds{limit}.":
    "{mitigation}؛ {cost}؛ ينخفض التعرّض إلى النصف ما دام التخفيف قائمًا{limit}.",
  "{quarter} next quarter plus {mitigation} of mitigation": "{quarter} الربع القادم إضافة إلى {mitigation} للتخفيف",
  "; {n} days to the limit": "؛ {n} يومًا حتى الحد",
  "Defer and accept": "التأجيل والقبول",
  "{cost}{year}; exposure rises{limit}.": "{cost}{year}؛ ويرتفع التعرّض{limit}.",
  "{amount} next quarter": "{amount} الربع القادم",
  ", {amount} in a year": "، {amount} خلال سنة",
  " and the limit is reached in {n} days, when this becomes mandatory":
    " ويُبلغ الحد خلال {n} يومًا، فيصبح هذا إلزاميًا",
  "nothing discretionary fits: the mandatory work alone exceeds the quarter":
    "لا يتسع أي بند اختياري: العمل الإلزامي وحده يتجاوز الربع",
  "The mandatory work alone needs {windows} windows, {cost} and {crewNights} crew-nights against {totalWindows}, {budget} and {totalCrewNights}. That is the decision: more resources, or a mandatory item that cannot be done in the quarter.":
    "العمل الإلزامي وحده يحتاج {windows} نافذة و{cost} و{crewNights} ليلة طاقم مقابل {totalWindows} و{budget} و{totalCrewNights}. هذا هو القرار: موارد أكثر، أو بند إلزامي لا يمكن تنفيذه في الربع.",
  "no night window left": "لم تبقَ نافذة ليلية",
  "over the budget left": "يتجاوز الميزانية المتبقية",
  "no crew-nights left": "لم تبقَ ليالي طواقم",
  "outranked on value per resource": "تفوّق عليه غيره في القيمة لكل مورد",
  "{n} resolved predictions on the ledger": "{n} تنبؤًا محسومًا في السجل",
  "confidence withheld — {predictions} on the ledger, {gate} needed":
    "الثقة محجوبة — {predictions} في السجل، والمطلوب {gate}",
  "{mandatory} first — not a decision. Then {chosen} of {total} discretionary items this quarter: {names}. Uses {windows} of {totalWindows} windows, {budget} of {totalBudget}, {crewNights} of {totalCrewNights} crew-nights.":
    "{mandatory} أولًا — ليس قرارًا. ثم {chosen} من {total} بندًا اختياريًا هذا الربع: {names}. يستخدم {windows} من {totalWindows} نافذة، و{budget} من {totalBudget}، و{crewNights} من {totalCrewNights} ليلة طاقم.",
  "{name}: {headline} — chosen on {basis}; score {score} on {coverage}.":
    "{name}: {headline} — اختير على أساس {basis}؛ الدرجة {score} على {coverage}.",
  "the components available": "المكوّنات المتاحة",
  "The strongest case against this allocation is {name}: {headline}, slipped because {why}. Slipping it costs {cost} over the quarter{limit}. If that is unacceptable, the trade is {trade}'s window.":
    "أقوى حجة ضد هذا التخصيص هي {name}: {headline}، تأجّل لأن {why}. تأجيله يكلّف {cost} على مدى الربع{limit}. إن كان ذلك غير مقبول، فالمقايضة هي نافذة {trade}.",
  "an unpriced amount": "مبلغًا غير مسعّر",
  " and the limit is {n} days away": " والحد على بُعد {n} يومًا",
  "one of the chosen items": "أحد البنود المختارة",
  "Nothing was slipped, so the case against this allocation is only that it spends what it spends.":
    "لم يتأجل شيء، لذا فالحجة الوحيدة ضد هذا التخصيص أنه ينفق ما ينفقه.",
  "{inputs} across {items} items are missing or from the starting rate card; entering them changes the consequence and cost terms first.":
    "{inputs} في {items} بنود ناقصة أو مأخوذة من بطاقة الأسعار الابتدائية؛ وإدخالها يغيّر حدّي العاقبة والتكلفة أولًا.",
  "{items} unpriced: a repair estimate on each would let the solver weigh them.":
    "{items} غير مسعّرة: تقدير إصلاح لكلٍّ منها يتيح لأداة الحل وزنها.",
  "{items} with no computable time to threshold: a second reading, or an entered rate, gives them a date.":
    "{items} بلا وقت محسوب حتى الحد: قراءة ثانية، أو معدل مُدخل، يمنحها تاريخًا.",
  "A change to the quarter's windows, budget or crews re-runs the solver; the weights are visible and editable, and the total moves with them.":
    "أي تغيير في نوافذ الربع أو ميزانيته أو طواقمه يعيد تشغيل أداة الحل؛ والأوزان ظاهرة وقابلة للتعديل، ويتحرك المجموع معها.",
  "Re-running the solver with {changes}.": "إعادة تشغيل أداة الحل مع {changes}.",
  "{n} windows": "{n} نوافذ",
  "a budget of {n}": "ميزانية قدرها {n}",
  "{n} crews": "{n} طواقم",
  "mandatory — not a decision": "إلزامي — ليس قرارًا",
  "chosen this quarter": "مختار هذا الربع",
  "slipped: {why}": "مؤجَّل: {why}",
  "{asset} — {headline}. {place}. Score {score} on {coverage}.":
    "{asset} — {headline}. {place}. الدرجة {score} على {coverage}.",
  ", slip cost {amount}": "، تكلفة التأجيل {amount}",
  "Nothing slipped.": "لم يتأجل شيء.",
  "Nothing is mandatory this quarter.": "لا شيء إلزامي هذا الربع.",
  "{n} resolved prediction|{n} resolved predictions":
    "لا تنبؤات محسومة|تنبؤ محسوم واحد|تنبؤان محسومان|{n} تنبؤات محسومة|{n} تنبؤًا محسومًا|{n} تنبؤ محسوم",
  "{n} mandatory item|{n} mandatory items":
    "لا بنود إلزامية|بند إلزامي واحد|بندان إلزاميان|{n} بنود إلزامية|{n} بندًا إلزاميًا|{n} بند إلزامي",
  "{n} input|{n} inputs": "لا مدخلات|مُدخل واحد|مُدخلان|{n} مدخلات|{n} مُدخلًا|{n} مُدخل",
  "Peak season": "موسم الذروة",
  "every hour of closure costs two and a half times as much in movements — the stress an Umrah or Hajj peak puts on the same works":
    "كل ساعة إغلاق تكلّف مرتين ونصفًا من الحركات — وهو الضغط الذي تفرضه ذروة العمرة أو الحج على الأعمال نفسها",
  "Budget cut of 20%": "خفض الميزانية بنسبة 20%",
  "the envelope drops to {amount}; an option costing more than that cannot be funded":
    "ينخفض المخصص إلى {amount}؛ ولا يمكن تمويل خيار يكلّف أكثر من ذلك",
  "An unplanned failure mid-works": "عطل غير مخطط أثناء الأعمال",
  "{hours} h of unplanned closure lands on top of the works — the longest on record, {ref} on {zone}":
    "{hours} ساعة من الإغلاق غير المخطط تُضاف إلى الأعمال — الأطول في السجل، {ref} على {zone}",
  "the airfield": "الجانب الجوي",
  "{hours} h of unplanned closure lands on top of the works (no unplanned closure on record; a starting value)":
    "{hours} ساعة من الإغلاق غير المخطط تُضاف إلى الأعمال (لا إغلاق غير مخطط في السجل؛ قيمة ابتدائية)",
  "The regulator arrives": "وصول الجهة التنظيمية",
  "an inspection lands before the option is complete: anything that leaves a crossed limit or an overdue obligation open fails":
    "يقع تفتيش قبل اكتمال الخيار: كل ما يترك حدًّا متجاوَزًا أو التزامًا متأخرًا مفتوحًا يرسب",
  "A 30-day slip": "تأخر 30 يومًا",
  "the contractor or the crew is a month late; an option that then runs past the horizon of {days} days is strained, past twice it fails":
    "يتأخر المقاول أو الطاقم شهرًا؛ الخيار الذي يتجاوز حينها الأفق البالغ {days} يومًا يكون مُجهَدًا، ويرسب إن تجاوز ضعفه",
  "the contractor or the crew is a month late": "يتأخر المقاول أو الطاقم شهرًا",
  "{cost} is over the cap of {cap}": "{cost} يتجاوز السقف البالغ {cap}",
  "leaves exposure {exposure} open when the inspector arrives": "يترك تعرّضًا قدره {exposure} مفتوحًا عند وصول المفتش",
  "{days} days runs past twice the {horizon}-day horizon": "{days} يومًا تتجاوز ضعف الأفق البالغ {horizon} يومًا",
  "not priced — cannot be tested": "غير مسعّر — لا يمكن اختباره",
  "{days} days runs past the {horizon}-day horizon": "{days} يومًا تتجاوز الأفق البالغ {horizon} يومًا",
  "{amount} cash-equivalent, {ratio}× its own baseline": "{amount} مكافئ نقدي، {ratio}× من أساسه",
  "No option survives every scenario; whichever is chosen needs a fallback written now.":
    "لا خيار يصمد أمام كل السيناريوهات؛ وأيًّا كان المختار فهو يحتاج إلى خطة بديلة تُكتب الآن.",
  "{name} has the best worst case: {amount} cash-equivalent in its hardest scenario, and it fails none.":
    "لـ «{name}» أفضل أسوأ حالة: {amount} مكافئ نقدي في أصعب سيناريوهاته، ولا يرسب في أي منها.",
  "the value of an hour of closure": "قيمة ساعة الإغلاق",
  "{amount}/h on the rate card": "{amount}/ساعة على بطاقة الأسعار",
  "above {amount}/h": "فوق {amount}/ساعة",
  "below {amount}/h": "دون {amount}/ساعة",
  "{name} wins": "يفوز «{name}»",
  // prettier-ignore
  "the cost of \"{name}\"": "تكلفة \"{name}\"",
  "above {amount}": "فوق {amount}",
  "No option is priced, so the room ranks none; enter an estimate beside the option to rank it.":
    "لا خيار مسعّر، لذا لا ترتّب الغرفة أيًّا منها؛ أدخل تقديرًا بجانب الخيار لترتيبه.",
  "Ranked on cash-equivalent: cash out plus closure hours priced at {rate}/h from the rate card. {name}: {amount}.":
    "مرتّبة حسب المكافئ النقدي: النقد المدفوع مضافًا إليه ساعات الإغلاق مسعّرة بـ {rate}/ساعة من بطاقة الأسعار. {name}: {amount}.",
  " — but it leaves less regulatory exposure": " — لكنه يترك تعرّضًا تنظيميًا أقل",
  "{names} is not priced and not ranked: {why}.": "{names} غير مسعّر وغير مرتّب: {why}.",
  " and ": " و",
  "{names} are not priced and not ranked: {why}.": "{names} غير مسعّرة وغير مرتّبة: {why}.",
  "{name} costs {amount} more on this arithmetic{exposure}{hours}. {against}":
    "«{name}» يكلّف {amount} أكثر وفق هذا الحساب{exposure}{hours}. {against}",
  " and leaves exposure {second} against {best}": " ويترك تعرّضًا قدره {second} مقابل {best}",
  ", and takes {n} fewer hours off the airfield": "، ويأخذ {n} ساعة أقل من الجانب الجوي",
  "The room recommends {name}{cost}{hours}.": "توصي الغرفة بـ «{name}»{cost}{hours}.",
  " at {amount}": " بتكلفة {amount}",
  " and {n} h off the airfield": " و{n} ساعة خارج الخدمة في الجانب الجوي",
  "The room makes no recommendation until an option is priced.": "لا تقدّم الغرفة توصية حتى يُسعَّر خيار.",
  "It is not the robust choice: under stress {robust} holds where {recommended} does not, so decide with the peak and the budget in view.":
    "ليس الخيار الأمتن: تحت الضغط يصمد «{robust}» حيث لا يصمد «{recommended}»، لذا قرّر والذروة والميزانية في الحسبان.",
  "It is also the option that survives every scenario tested.": "وهو أيضًا الخيار الذي يصمد أمام كل سيناريو مُختبَر.",
  "No option survives every scenario; a fallback should be written with the decision.":
    "لا خيار يصمد أمام كل السيناريوهات؛ ينبغي كتابة خطة بديلة مع القرار.",
  condition: "الحالة الفنية",
  "days to the limit": "أيام حتى الحد",
  "the limit is already crossed": "الحد متجاوَز فعلًا",
  "not computable: {basis}": "غير قابل للحساب: {basis}",
  "{n} days on the trend ({basis})": "{n} يومًا وفق الاتجاه ({basis})",
  "movements in a closure": "الحركات في إغلاق",
  movements: "حركات",
  "{movements} movements in the capacity model's {hours} h window: {stranded} stranded, {bussed} bussed":
    "{movements} حركة في نافذة نموذج السعة البالغة {hours} ساعة: {stranded} عالقة، و{bussed} منقولة بالحافلات",
  "the capacity model does not cover the window: {why}": "لا يغطي نموذج السعة النافذة: {why}",
  "no schedule loaded": "لا جدول رحلات محمّل",
  "an hour of runway closure": "ساعة إغلاق المدرج",
  "{amount} per hour on the rate card — the figure every option below is judged on":
    "{amount} لكل ساعة على بطاقة الأسعار — الرقم الذي يُقاس عليه كل خيار أدناه",
  "other work waiting here": "أعمال أخرى تنتظر هنا",
  "nothing else is waiting on this runway": "لا شيء آخر ينتظر على هذا المدرج",
  "the capacity model has no schedule for {zone}, so movements in a closure are unknown and the rate card stands in":
    "لا يملك نموذج السعة جدولًا لـ {zone}، لذا الحركات في الإغلاق غير معروفة وتحل بطاقة الأسعار محلها",
  "Treat it in night windows": "المعالجة في نوافذ ليلية",
  "{work} done in the next night window, {hours} h at a time, the runway open by day":
    "{work} يُنفَّذ في النافذة الليلية القادمة، {hours} ساعة في كل مرة، والمدرج مفتوح نهارًا",
  closure: "الإغلاق",
  "{n} h, at night": "{n} ساعة، ليلًا",
  "movements touched": "الحركات المتأثرة",
  "{touched} of {movements}": "{touched} من {movements}",
  "0 — the limit is restored": "0 — يُستعاد الحد",
  "Cheapest and quickest; the runway is never closed in daylight.": "الأرخص والأسرع؛ لا يُغلق المدرج نهارًا أبدًا.",
  "Repeatable: the same window serves the next treatment.": "قابل للتكرار: النافذة نفسها تخدم المعالجة التالية.",
  "Treats the symptom: the trend says it returns, and the survey cadence has to be kept.":
    "يعالج العَرَض: يقول الاتجاه إنه سيعود، ويجب الحفاظ على وتيرة المسوح.",
  "One full closure, everything at once": "إغلاق كامل واحد، كل شيء دفعة واحدة",
  "close {zone} once for {hours} h and do the treatment with the {jobs} waiting on it":
    "أغلق {zone} مرة واحدة لمدة {hours} ساعة ونفّذ المعالجة مع {jobs} المنتظرة عليه",
  "{n} h in one closure{longest}": "{n} ساعة في إغلاق واحد{longest}",
  " (the longest on record, {ref})": " (الأطول في السجل، {ref})",
  "{n} in the window": "{n} ضمن النافذة",
  "0 — everything on the section is cleared": "0 — يُنجَز كل ما على المقطع",
  "One mobilisation and one NOTAM instead of several.": "تعبئة واحدة وإشعار للطيارين (NOTAM) واحد بدلًا من عدة.",
  "Clears every open item on the runway in one go.": "يُنجز كل بند مفتوح على المدرج دفعة واحدة.",
  "A daytime closure is a one-way door once notified; the movements in it are moved or lost.":
    "الإغلاق النهاري قرار لا رجعة فيه بمجرد الإشعار به؛ والحركات فيه تُنقل أو تُفقد.",
  "Treat now, resurface the section next year": "المعالجة الآن، وإعادة رصف المقطع العام القادم",
  "the interim treatment now, and the section put to the next capital envelope for resurfacing":
    "المعالجة المؤقتة الآن، وإدراج المقطع في المخصص الرأسمالي القادم لإعادة الرصف",
  "the platform holds no priced resurfacing candidate for this section; enter an estimate to rank it":
    "لا تملك المنصة مرشحًا مسعّرًا لإعادة رصف هذا المقطع؛ أدخل تقديرًا لترتيبه",
  "{estimate} + {interim} interim": "{estimate} + {interim} مؤقتة",
  "0 now; the recurrence ends with the resurfacing": "0 الآن؛ وينتهي التكرار بإعادة الرصف",
  door: "الباب",
  "one-way — capital committed": "باتجاه واحد — رأس مال ملتزَم به",
  "a share of the FY{year} envelope": "حصة من مخصص السنة المالية FY{year}",
  "Ends the recurrence instead of treating it each quarter.": "ينهي التكرار بدلًا من معالجته كل ربع.",
  "Commits capital the register has not priced; the estimate is the whole argument.":
    "يلتزم برأس مال لم يسعّره السجل؛ والتقدير هو الحجة كلها.",
  "resurfacing estimate": "تقدير إعادة الرصف",
  "the limit is crossed: the treatment has to be in the next fortnight's windows":
    "الحد متجاوَز: يجب أن تكون المعالجة في نوافذ الأسبوعين القادمين",
  "{n} days to the limit on the trend": "{n} يومًا حتى الحد وفق الاتجاه",
  "no trend to date it: {basis}": "لا اتجاه لتأريخه: {basis}",
  "{zone} below its limit": "{zone} دون حده",
  "{zone} is {condition}. Treat it in nights, take the runway once for everything, or commit to resurfacing?":
    "{zone} حالته {condition}. هل يُعالَج في الليالي، أم يُؤخذ المدرج مرة واحدة لكل شيء، أم يُلتزم بإعادة الرصف؟",
  "{why} — the work is not a decision, how to do it is.": "{why} — العمل ليس قرارًا، أما طريقة تنفيذه فهي القرار.",
  "a crossed limit is treated within the month": "الحد المتجاوَز يُعالَج خلال الشهر",
  "{n} days to the limit": "{n} يومًا حتى الحد",
  "no trend to date it": "لا اتجاه لتأريخه",
  "the treatment can be repeated; only the full closure and the capital commitment are one-way":
    "يمكن تكرار المعالجة؛ الإغلاق الكامل والالتزام الرأسمالي وحدهما بلا رجعة",
  "a night window taken here is one fewer for {assets} this quarter":
    "النافذة الليلية المأخوذة هنا نافذة أقل لـ {assets} هذا الربع",
  "{items} sit on the same runway and can share the closure": "{items} على المدرج نفسه ويمكنها مشاركة الإغلاق",
  "{n} movements are bussed in a closure of the capacity model's window — a passenger cost the rate card does not carry":
    "{n} حركة تُنقل بالحافلات في إغلاق ضمن نافذة نموذج السعة — تكلفة على المسافرين لا تحملها بطاقة الأسعار",
  "deferred-cost curve": "منحنى تكلفة التأجيل",
  "Fund {amount}": "تمويل {amount}",
  "{funded} of {priced} priced candidates funded, {deferred} deferred":
    "تمويل {funded} من {priced} مرشحًا مسعّرًا، وتأجيل {deferred}",
  "cash out": "النقد المدفوع",
  "cost of waiting a year": "تكلفة الانتظار سنة",
  "closure hours a year, deferred work": "ساعات الإغلاق سنويًا، الأعمال المؤجلة",
  "{hours} h (known for {known}, unknown for {unknown})": "{hours} ساعة (معروفة لـ {known}، غير معروفة لـ {unknown})",
  deferred: "مؤجَّل",
  "Nothing deferred: no escalation and no closure hours carried into the year after.":
    "لا شيء مؤجَّل: لا تصاعد ولا ساعات إغلاق تُرحَّل إلى السنة التالية.",
  "Keeps {amount} of capital uncommitted.": "يُبقي {amount} من رأس المال غير ملتزَم به.",
  "The largest cash call, in a year the envelope may be cut.": "أكبر طلب نقدي، في سنة قد يُخفَّض فيها المخصص.",
  "Waiting costs {amount} and {hours} closure hours the operation pays for.":
    "الانتظار يكلّف {amount} و{hours} ساعة إغلاق تدفع ثمنها العمليات.",
  candidates: "المرشحون",
  "{candidates} candidates on the register, {priced} priced — {note}":
    "{candidates} مرشحًا في السجل، {priced} منها مسعّرة — {note}",
  "cost of waiting": "تكلفة الانتظار",
  "{amount} a year at the lowest envelope": "{amount} سنويًا عند أدنى مخصص",
  "closure hours deferred work costs": "ساعات الإغلاق التي تكلّفها الأعمال المؤجلة",
  "{hours} h a year at the lowest envelope, priced here at {rate}/h":
    "{hours} ساعة سنويًا عند أدنى مخصص، مسعّرة هنا بـ {rate}/ساعة",
  "closure cost per hour, taxiway and apron": "تكلفة الإغلاق لكل ساعة، ممر الطائرات وساحة وقوف الطائرات",
  "held up by a missing fact": "معطّل بسبب حقيقة ناقصة",
  "{amount} of priced, funded work is blocked by a missing fact, not by money":
    "{amount} من الأعمال المسعّرة والممولة معطّلة بسبب حقيقة ناقصة، لا بسبب المال",
  "the program": "البرنامج",
  "The FY{year} envelope": "مخصص السنة المالية FY{year}",
  "How much capital goes to the register next year: {envelopes}?":
    "كم من رأس المال يذهب إلى السجل العام القادم: {envelopes}؟",
  "{priced} priced candidates want {amount}; every year of waiting costs {waiting} at the lowest envelope.":
    "{priced} مرشحًا مسعّرًا تحتاج {amount}؛ وكل سنة انتظار تكلّف {waiting} عند أدنى مخصص.",
  "before the budget is set for the year": "قبل تحديد ميزانية السنة",
  "the fiscal year": "السنة المالية",
  "escalation on deferred work is not recovered by funding it later":
    "تصاعد تكلفة الأعمال المؤجلة لا يُسترد بتمويلها لاحقًا",
  "Cash-equivalent here is cash out plus the cost of waiting a year plus the deferred closure hours at {rate}/h.":
    "المكافئ النقدي هنا هو النقد المدفوع مضافًا إليه تكلفة الانتظار سنة وساعات الإغلاق المؤجلة بـ {rate}/ساعة.",
  "{n} candidates are unpriced and in none of these figures: {detail}.":
    "{n} مرشحًا غير مسعّرة وغير داخلة في أي من هذه الأرقام: {detail}.",
  "{n} candidates cannot be scheduled whatever the envelope until someone supplies a fact: {detail}":
    "{n} مرشحًا لا يمكن جدولتها مهما كان المخصص حتى يقدّم أحد حقيقة: {detail}",
  "the top envelope of {top} funds everything priced and leaves {left} unspent":
    "أعلى مخصص البالغ {top} يموّل كل ما هو مسعّر ويترك {left} غير منفق",
  "{n} of {candidates} candidates carry no price": "{n} من {candidates} مرشحًا بلا سعر",
  "the next peak": "الذروة القادمة",
  "days to the peak": "أيام حتى الذروة",
  "{peak} starts {date}{assumed}": "تبدأ {peak} في {date}{assumed}",
  " — a starting value; enter the real date": " — قيمة ابتدائية؛ أدخل التاريخ الحقيقي",
  "peak dates": "تواريخ الذروة",
  "open at severity 4 or 5": "مفتوحة بخطورة 4 أو 5",
  findings: "ملاحظات",
  "nothing open at severity 4 or 5": "لا شيء مفتوح بخطورة 4 أو 5",
  "major equipment out of service": "معدات رئيسية خارج الخدمة",
  "{value} {unit} against a target of {target} ({source})": "{value} {unit} مقابل مستهدف قدره {target} ({source})",
  "no equipment KPI on the platform": "لا مؤشر أداء رئيسي (KPI) للمعدات على المنصة",
  positions: "مواقع",
  "{position} ({n} stranded)": "{position} ({n} عالقة)",
  "unknown: {why}": "غير معروف: {why}",
  "obligations overdue": "التزامات متأخرة",
  "none overdue": "لا شيء متأخر",
  "runway availability is not computable: {why}": "إتاحة المدرج غير قابلة للحساب: {why}",
  "no operational periods": "لا فترات تشغيلية",
  "the capacity model does not cover the peak window": "لا يغطي نموذج السعة نافذة الذروة",
  "Readiness sprint": "دفعة الجاهزية",
  "clear the {n} mandatory items and the severity 4–5 findings before {peak}, and nothing else airside until it ends":
    "إنجاز البنود الإلزامية الـ {n} وملاحظات الخطورة 4–5 قبل {peak}، ولا شيء آخر في الجانب الجوي حتى تنتهي",
  "{now} now + {slip} of slip on what waits": "{now} الآن + {slip} تكلفة تأجيل على ما ينتظر",
  "{n} h, all before the peak": "{n} ساعة، كلها قبل الذروة",
  "{used} of {total}": "{used} من {total}",
  "0 — nothing mandatory is open when the peak starts": "0 — لا شيء إلزامي مفتوح عند بدء الذروة",
  "The peak starts with no crossed limit and no overdue obligation on the books.":
    "تبدأ الذروة بلا حد متجاوَز ولا التزام متأخر في السجلات.",
  "Everything discretionary slips a quarter and escalates.": "كل ما هو اختياري يتأجل ربعًا وتتصاعد تكلفته.",
  "Run the quarter as solved": "تنفيذ الربع كما حلّته الأداة",
  "the solver's {n} items go ahead on their windows, some of them inside the peak":
    "بنود أداة الحل الـ {n} تمضي في نوافذها، وبعضها داخل الذروة",
  "{n} h across the quarter": "{n} ساعة على مدى الربع",
  "{n} left on the slipped set": "{n} متبقٍّ على المجموعة المؤجلة",
  "The most work done for the money; nothing waits that the solver could fit.":
    "أكبر قدر من العمل مقابل المال؛ لا ينتظر شيء كان بإمكان أداة الحل إدراجه.",
  "Night closures run through the peak, when an hour of closure costs the most.":
    "تستمر الإغلاقات الليلية خلال الذروة، حين تكون ساعة الإغلاق الأعلى تكلفة.",
  "Freeze airside works through the peak": "تجميد أعمال الجانب الجوي خلال الذروة",
  "the mandatory items before {peak}, then no planned closure until it ends; everything else after":
    "البنود الإلزامية قبل {peak}، ثم لا إغلاق مخطط حتى تنتهي؛ وكل ما عدا ذلك بعدها",
  "{now} now, {escalation} of escalation on the rest": "{now} الآن، و{escalation} تصاعدًا على الباقي",
  "{n} h before the peak, none in it": "{n} ساعة قبل الذروة، ولا شيء خلالها",
  "{n} carried through the peak": "{n} مُرحَّل خلال الذروة",
  "two-way — the frozen work resumes after": "باتجاهين — يُستأنف العمل المجمَّد بعدها",
  "No planned closure while the airport is fullest.": "لا إغلاق مخطط والمطار في أشد ازدحامه.",
  "Discretionary findings drift through the peak; anything that fails then is an unplanned closure at the worst time.":
    "تتدهور الملاحظات الاختيارية خلال الذروة؛ وأي عطل حينها إغلاق غير مخطط في أسوأ وقت.",
  "Ready for {peak}": "الجاهزية لـ {peak}",
  "{peak} starts in {n} days. Sprint the mandatory set, run the quarter as solved, or freeze airside works through it?":
    "تبدأ {peak} بعد {n} يومًا. هل تُنجز المجموعة الإلزامية بسرعة، أم يُنفَّذ الربع كما حُلّ، أم تُجمَّد أعمال الجانب الجوي خلالها؟",
  "{findings} open at severity 4 or 5, {obligations} overdue{outages}.":
    "{findings} مفتوحة بخطورة 4 أو 5، و{obligations} متأخرة{outages}.",
  ", {value} {unit} of major equipment out of service": "، و{value} {unit} من المعدات الرئيسية خارج الخدمة",
  "three weeks before the peak, so the windows can still be booked":
    "قبل الذروة بثلاثة أسابيع، ليظل حجز النوافذ ممكنًا",
  "before {peak} starts": "قبل بدء {peak}",
  "works can be re-sequenced up to the day; what cannot be undone is an unplanned closure in the peak":
    "يمكن إعادة ترتيب الأعمال حتى اليوم نفسه؛ ما لا يمكن التراجع عنه هو إغلاق غير مخطط في الذروة",
  "{positions} cannot be closed in the window without stranding traffic — any work there goes before or after":
    "{positions} لا يمكن إغلاقها في النافذة دون تعليق الحركة — أي عمل هناك يكون قبلها أو بعدها",
  "equipment out of service is above target; the peak arrives with {value} {unit} down unless the repairs are in the sprint":
    "المعدات خارج الخدمة فوق المستهدف؛ ستصل الذروة و{value} {unit} معطّلة ما لم تكن الإصلاحات ضمن الدفعة",
  "{met} of {total} obligations met, {overdue} overdue": "{met} من {total} التزامًا مستوفى، و{overdue} متأخرة",
  "targets still proposed": "مستهدفات لا تزال مقترحة",
  "{n} KPI targets are proposed, not agreed — a grade against them is not a finding":
    "{n} من مستهدفات مؤشرات الأداء الرئيسية (KPI) مقترحة لا متفق عليها — والتقدير مقابلها ليس ملاحظة",
  "every KPI target on the platform is agreed or from the pack":
    "كل مستهدفات مؤشرات الأداء الرئيسية (KPI) على المنصة متفق عليها أو من الحزمة",
  "Close every gap first": "سدّ كل فجوة أولًا",
  "the {mandatory} mandatory items done and the {overdue} overdue obligations evidenced before {date}":
    "إنجاز البنود الإلزامية الـ {mandatory} وتوثيق الالتزامات المتأخرة الـ {overdue} بالأدلة قبل {date}",
  needs: "يحتاج",
  "{n} night windows and the evidence filed": "{n} نافذة ليلية وتقديم الأدلة",
  "The inspector finds a closed book.": "يجد المفتش ملفًا مكتملًا.",
  "Takes the quarter's windows and crews off everything else.": "يأخذ نوافذ الربع وطواقمه من كل ما عداه.",
  "Disclose, with a dated plan and mitigations": "الإفصاح، مع خطة مؤرّخة وإجراءات تخفيف",
  "each open item declared with its mitigation in place and the date it closes":
    "إعلان كل بند مفتوح مع إجراء التخفيف القائم وتاريخ إغلاقه",
  "{amount} of mitigations": "{amount} لإجراءات التخفيف",
  "none before the inspection": "لا شيء قبل التفتيش",
  "0.4 — declared, mitigated, dated": "0.4 — مُعلَن، مُخفَّف، مؤرّخ",
  mitigations: "إجراءات التخفيف",
  "A documented, dated, mitigated plan is what an inspector is trained to accept.":
    "الخطة الموثّقة والمؤرّخة والمخفَّفة هي ما تدرّب المفتش على قبوله.",
  "An undertaking to the regulator is a hard date, and missing it is worse than not making it.":
    "التعهد للجهة التنظيمية موعد ملزم، وتفويته أسوأ من عدم تقديمه.",
  "mitigation cost by category": "تكلفة التخفيف حسب الفئة",
  "The crossed limits only": "الحدود المتجاوَزة فقط",
  "fix the {limits}; the overdue obligations are evidenced but not the rest":
    "إصلاح {limits}؛ وتوثيق الالتزامات المتأخرة بالأدلة دون الباقي",
  "{exposure} — {obligations} still open": "{exposure} — {obligations} لا تزال مفتوحة",
  "The finding that would ground a runway is gone; the rest is paperwork.":
    "زالت الملاحظة التي كانت ستوقف مدرجًا؛ والباقي أعمال ورقية.",
  "An overdue obligation is a finding in its own right under Part 139.":
    "الالتزام المتأخر ملاحظة قائمة بذاتها بموجب GACAR Part 139.",
  "In front of the regulator": "أمام الجهة التنظيمية",
  "An inspection in {n} days. Close every gap first, disclose with a dated plan, or fix the crossed limits only?":
    "تفتيش بعد {n} يومًا. هل تُسَدّ كل فجوة أولًا، أم يُفصَح بخطة مؤرّخة، أم تُصلَح الحدود المتجاوَزة فقط؟",
  "{limits} crossed, {obligations} overdue, {n} due before the inspection.":
    "{limits} متجاوَزة، و{obligations} متأخرة، و{n} مستحقة قبل التفتيش.",
  "a fortnight before, so what is promised can be evidenced": "قبل أسبوعين، ليمكن إثبات ما يُوعَد به بالأدلة",
  "before the inspection": "قبل التفتيش",
  "nothing here is irreversible except an undertaking given in writing": "لا شيء هنا بلا رجعة إلا تعهد مكتوب",
  "{items} fall due before the inspection and join the list if missed":
    "{items} تستحق قبل التفتيش وتنضم إلى القائمة إن فاتت",
  "{n} proposed KPI targets should be agreed or withdrawn before an inspector reads a grade against them":
    "{n} من مستهدفات مؤشرات الأداء الرئيسية (KPI) المقترحة ينبغي الاتفاق عليها أو سحبها قبل أن يقرأ مفتش تقديرًا مقابلها",
  "{meaning}: {chosen} discretionary items after the {mandatory} mandatory":
    "{meaning}: {chosen} بندًا اختياريًا بعد الإلزامية الـ {mandatory}",
  spend: "الإنفاق",
  "{used} of {available}, {avoided} of escalation avoided": "{used} من {available}، مع تجنّب {avoided} من التصاعد",
  exposure: "التعرّض",
  "{retired} retired, {left} left on the slipped set": "{retired} زال، و{left} متبقٍّ على المجموعة المؤجلة",
  slips: "المؤجَّل",
  "the quarter's constraints": "قيود الربع",
  "The solver's set": "مجموعة أداة الحل",
  "the default weights": "الأوزان الافتراضية",
  "The best value per window, budget and crew-night on the weights as set.":
    "أفضل قيمة لكل نافذة وميزانية وليلة طاقم وفق الأوزان المحددة.",
  "It is only as good as the weights, which are the executive's to move.":
    "جودتها بقدر جودة الأوزان، وتحريكها بيد الإدارة التنفيذية.",
  "Protect availability": "حماية الإتاحة",
  "consequence weighted to 0.5": "العاقبة بوزن 0.5",
  "Runway and taxiway hours come first; the airfield stays open.":
    "ساعات المدرج وممر الطائرات أولًا؛ ويبقى الجانب الجوي مفتوحًا.",
  "Regulatory findings wait.": "الملاحظات التنظيمية تنتظر.",
  "Retire exposure": "إزالة التعرّض",
  "regulatory exposure weighted to 0.5": "التعرّض التنظيمي بوزن 0.5",
  "Every clause-bearing finding is retired first.": "كل ملاحظة تحمل بندًا تُزال أولًا.",
  "Availability is spent on it.": "تُستهلك الإتاحة عليها.",
  "night windows": "النوافذ الليلية",
  "{n} this quarter, {taken} taken by the mandatory set": "{n} هذا الربع، تأخذ المجموعة الإلزامية {taken} منها",
  "the quarter": "الربع",
  "{amount}; the mandatory set alone is {mandatory}": "{amount}؛ والمجموعة الإلزامية وحدها {mandatory}",
  "findings in play": "الملاحظات المطروحة",
  "{mandatory} mandatory, {discretionary} discretionary": "{mandatory} إلزامية، و{discretionary} اختيارية",
  confidence: "الثقة",
  "The windows of {quarter}": "نوافذ {quarter}",
  "{n} night windows and {amount}: the solver's set, protect availability, or retire exposure first?":
    "{n} نافذة ليلية و{amount}: مجموعة أداة الحل، أم حماية الإتاحة، أم إزالة التعرّض أولًا؟",
  "{mandatory} items are mandatory and pre-committed; {rest} compete for what is left.":
    "{mandatory} بنود إلزامية وملتزَم بها مسبقًا؛ و{rest} تتنافس على ما تبقى.",
  "before the first window of the quarter is booked": "قبل حجز أول نافذة في الربع",
  "the weights and the constraints can be moved and the quarter re-solved at any time":
    "يمكن تحريك الأوزان والقيود وإعادة حل الربع في أي وقت",
  "Cash-equivalent here is spend less the escalation avoided, plus the closure hours priced at the taxiway rate.":
    "المكافئ النقدي هنا هو الإنفاق مطروحًا منه التصاعد المُتجنَّب، مضافًا إليه ساعات الإغلاق مسعّرة بسعر ممر الطائرات.",
  "{items} slip under the solver's set{detail}": "{items} تتأجل ضمن مجموعة أداة الحل{detail}",
  " ({amount} to slip)": " ({amount} للتأجيل)",
  "No counter-argument: only one option is priced.": "لا حجة مضادة: خيار واحد فقط مسعّر.",
  "{name} displaces {items}.": "«{name}» يُزيح {items}.",
  "{name} displaces nothing on the platform's records.": "«{name}» لا يُزيح شيئًا في سجلات المنصة.",
  "{name}: {meaning}. {cost}{closure}, exposure {exposure} after. For: {for} Against: {against}":
    "{name}: {meaning}. {cost}{closure}، والتعرّض بعده {exposure}. مع: {for} ضد: {against}",
  "Not priced": "غير مسعّر",
  ", {n} h of closure": "، {n} ساعة إغلاق",
  "{n} other job|{n} other jobs":
    "لا أعمال أخرى|العمل الآخر|العملين الآخرين|الأعمال الأخرى الـ {n}|الأعمال الأخرى الـ {n}|الأعمال الأخرى الـ {n}",
  "{n} obligation|{n} obligations": "لا التزامات|التزام واحد|التزامان|{n} التزامات|{n} التزامًا|{n} التزام",
  "no date the platform can give": "لا تاريخ تستطيع المنصة تقديمه",
  "today ({when})": "اليوم ({when})",
  "no priced cost": "لا تكلفة مسعّرة",
  "no responsible party on record": "لا طرف مسؤول في السجل",
  "{kind} · severity {severity} · raised {date} · alert {id}":
    "{kind} · الخطورة {severity} · أُطلق {date} · التنبيه {id}",
  "now {amount}": "الآن {amount}",
  ", deferred {amount}": "، مؤجَّل {amount}",
  "not priced — {why}": "غير مسعّر — {why}",
  "no basis": "بلا أساس",
  "{now} to do now; {deferred} if deferred — from the deferred-cost register.":
    "{now} للتنفيذ الآن؛ {deferred} إذا أُجّل — من سجل تكلفة التأجيل.",
  "{amount} from the deferred-cost register.": "{amount} من سجل تكلفة التأجيل.",
  "Not priced: {why}. The platform does not guess a figure.": "غير مسعّر: {why}. المنصة لا تخمّن رقمًا.",
  "the register holds no rate for it": "لا يحمل السجل سعرًا له",
  "{amount} planned on the work order.": "{amount} مخطط على أمر العمل.",
  "Not priced: nothing in the deferred-cost register or on a work order names this. The platform does not guess a figure.":
    "غير مسعّر: لا شيء في سجل تكلفة التأجيل أو على أمر عمل يسمّي هذا. المنصة لا تخمّن رقمًا.",
  "{discipline} discipline": "تخصص {discipline}",
  "{number} sits with the {discipline} discipline{late}, with no crew named on it. Naming one is the operator's decision.":
    "{number} لدى تخصص {discipline}{late}، دون طاقم مسمّى عليه. وتسمية طاقم قرار المشغّل.",
  "{number} is {status} with no crew or discipline on it, so there is nobody to hold to it yet. Assigning it is the operator's decision.":
    "{number} في حالة {status} دون طاقم أو تخصص عليه، لذا لا أحد يُسأل عنه بعد. وإسناده قرار المشغّل.",
  "{crew} holds {number}{late} and still {status}.": "{crew} مسؤول عن {number}{late} وما زال {status}.",
  "{crew} holds {number}, {status}{due}.": "{crew} مسؤول عن {number}، {status}{due}.",
  "{crew} last worked this on {number} ({status}).": "{crew} عمل على هذا آخر مرة في {number} ({status}).",
  // prettier-ignore
  "{title}{many}. The rule \"{rule}\" expects it{by}{confidence}.": "{title}{many}. تتوقعه القاعدة \"{rule}\"{by}{confidence}.",
  " — {n} of them": " — {n} منها",
  ", and {n} more": "، و{n} أخرى",
  " by {date}": " بحلول {date}",
  " with {pct}% confidence": " بثقة {pct}%",
  // prettier-ignore
  "{title}. Already failing: the rule \"{rule}\" fired on the platform's own readings.": "{title}. متعطل فعلًا: انطلقت القاعدة \"{rule}\" على قراءات المنصة نفسها.",
  "No work has been raised for this yet, so there is nobody to hold to it. Raising it is the operator's decision — the alert has a button for it.":
    "لم يُنشأ عمل لهذا بعد، لذا لا أحد يُسأل عنه. وإنشاؤه قرار المشغّل — وفي التنبيه زر لذلك.",
  "The alert stands with no work order against it. Nobody is on it.": "التنبيه قائم دون أمر عمل عليه. لا أحد يتولاه.",
  "threshold verified{against}{on}": "الحد موثَّق{against}{on}",
  " against {what}": " مقابل {what}",
  "unverified threshold: the rule's parameters have not been confirmed against a source document":
    "حد غير موثَّق: لم تُؤكَّد معاملات القاعدة مقابل وثيقة مصدر",
  "disabled rule: {reason}": "قاعدة معطّلة: {reason}",
  "the rule is switched off": "القاعدة موقوفة",
  "the readings that fired the rule are on record": "القراءات التي أطلقت القاعدة مسجّلة",
  "confirmed by a person": "أكّده شخص",
  "dismissed by a person on review": "رفضه شخص عند المراجعة",
  "the model's last check ({date}) found it still describes the estate":
    "وجد آخر فحص للنموذج ({date}) أنه لا يزال يصف الأصول",
  // prettier-ignore
  "model drift: the last check found \"{verdict}\"": "انحراف النموذج: وجد آخر فحص \"{verdict}\"",
  "model check inconclusive: {verdict}": "فحص النموذج غير حاسم: {verdict}",
  "no drift check is on record for the model behind this prediction": "لا فحص انحراف مسجّل للنموذج وراء هذا التنبؤ",
  "confidence {pct}% is below the level the platform treats as firm":
    "الثقة {pct}% دون المستوى الذي تعدّه المنصة راسخًا",
  "no crew named, only the discipline": "لا طاقم مسمّى، التخصص فقط",
  "{title} — {items}": "{title} — {items}",
  "open since {date}": "مفتوح منذ {date}",
  "opened, due and current state are the platform's own dated records":
    "تاريخ الفتح والاستحقاق والحالة الحالية سجلات مؤرّخة للمنصة نفسها",
  "every transition is on the audit trail": "كل انتقال مسجّل في سجل التدقيق",
  "{number} is past due with nobody on it.": "{number} تجاوز موعده ولا أحد يتولاه.",
  "{number} past its due date: {title}": "{number} تجاوز تاريخ استحقاقه: {title}",
  "{days} overdue (due {date})": "متأخر {days} (الاستحقاق {date})",
  "Priority {priority} work is {days} past the date it was due, and still {status}. Whatever it was raised to prevent is now unprotected.":
    "عمل بالأولوية P{priority} تجاوز تاريخ استحقاقه بـ {days}، وما زال {status}. وكل ما أُنشئ لمنعه صار الآن بلا حماية.",
  "Opened {date}": "فُتح {date}",
  ", SLA {h} h": "، اتفاقية مستوى الخدمة {h} ساعة",
  "the last record {ref} is on file with its result": "آخر سجل {ref} محفوظ مع نتيجته",
  "the test interval is proposed, not agreed with the regulator":
    "فترة الاختبار مقترحة، غير متفق عليها مع الجهة التنظيمية",
  "demonstration record: not a real test": "سجل عرض توضيحي: ليس اختبارًا حقيقيًا",
  "the result was never judged": "لم تُقيَّم النتيجة قط",
  "performed {date}{by} · {basis}": "نُفّذ {date}{by} · {basis}",
  " by {name}": " بواسطة {name}",
  "{name} failed its last test": "{name} رسب في آخر اختبار",
  "{name} is overdue": "{name} متأخر",
  "{name} falls due soon": "{name} يستحق قريبًا",
  "never tested": "لم يُختبر قط",
  "no interval agreed": "لا فترة متفق عليها",
  // prettier-ignore
  "The last {name} came back \"fail\" ({basis}). Until it passes, the surface or system it covers is out of tolerance on the platform's own record.": "جاءت نتيجة آخر {name} \"راسب\" ({basis}). وحتى ينجح، يبقى السطح أو النظام الذي يغطيه خارج التفاوت المسموح وفق سجل المنصة نفسها.",
  "against its threshold": "مقابل حده",
  "The {name} is past its interval{interval}. The platform cannot say the surface is within limits, because nobody has measured it in time.":
    "تجاوز {name} فترته{interval}. لا تستطيع المنصة القول إن السطح ضمن الحدود، لأن أحدًا لم يقِسه في الوقت.",
  " of {n} days": " البالغة {n} يومًا",
  "The {name} falls due{when}{interval}.": "يستحق {name}{when}{interval}.",
  " shortly": " قريبًا",
  " (interval {n} days)": " (الفترة {n} يومًا)",
  "Mandatory under {frameworks} · {records} on file": "إلزامي بموجب {frameworks} · {records} في الملف",
  "the operator's own program": "برنامج المشغّل نفسه",
  "Not priced: a missed test carries a regulatory exposure, not a repair cost the register can hold.":
    "غير مسعّر: الاختبار الفائت يحمل تعرّضًا تنظيميًا، لا تكلفة إصلاح يمكن للسجل حملها.",
  "The obligation to test is the operator's own; the platform names no contractor for it.":
    "الالتزام بالاختبار على المشغّل نفسه؛ ولا تسمّي المنصة مقاولًا له.",
  "no evidence filed against the obligation": "لا أدلة مقدَّمة على الالتزام",
  "Overdue obligation: {title}": "التزام متأخر: {title}",
  "Obligation due: {title}": "التزام مستحق: {title}",
  // prettier-ignore
  "{framework} requires \"{title}\"{period}, and the platform holds it as overdue.": "يتطلب {framework} \"{title}\"{period}، والمنصة تعدّه متأخرًا.",
  " for {period}": " عن {period}",
  // prettier-ignore
  "{framework} requires \"{title}\"{period} by {date}.": "يتطلب {framework} \"{title}\"{period} بحلول {date}.",
  "Compliance framework {framework}": "إطار الامتثال {framework}",
  "Not priced: the exposure is regulatory, not a repair the register can hold.":
    "غير مسعّر: التعرّض تنظيمي، لا إصلاح يمكن للسجل حمله.",
  "An obligation is the operator's own; the platform names no contractor for it.":
    "الالتزام على المشغّل نفسه؛ ولا تسمّي المنصة مقاولًا له.",
  "fitted on {units} units, {failures} failures, {censored} still running ({method})":
    "ملاءمة على {units} وحدة، و{failures} عطلًا، و{censored} لا تزال تعمل ({method})",
  "constant-rate model rejected at 95% (likelihood ratio {ratio} against {critical})":
    "رُفض نموذج المعدل الثابت عند 95% (نسبة الأرجحية {ratio} مقابل {critical})",
  "the shape is loosely known (β {low}–{high})": "الشكل معروف بتقريب واسع (β {low}–{high})",
  "individual unit ages are not held, so the platform cannot say which unit fails first":
    "أعمار الوحدات الفردية غير محفوظة، لذا لا تستطيع المنصة تحديد أي وحدة تتعطل أولًا",
  "{population} population is wearing out": "مجموعة {population} في طور الاهتراء",
  "failures cluster toward {eta} {unit} of service": "تتركز الأعطال قرب {eta} {unit} من الخدمة",
  "{units} units of {population} follow a wear-out law (shape β {beta} > 1): the older a unit, the likelier it fails, with the characteristic life at {eta} {unit}. {note}":
    "{units} وحدة من {population} تتبع قانون الاهتراء (الشكل β {beta} > 1): كلما كبرت الوحدة زاد احتمال تعطلها، والعمر المميز عند {eta} {unit}. {note}",
  "Replacement should be planned by age, not by failure.": "ينبغي تخطيط الاستبدال حسب العمر، لا حسب العطل.",
  "Survival fit {id}{fitted}": "ملاءمة البقاء {id}{fitted}",
  ", fitted {date}": "، أُجريت {date}",
  "Not priced: a population-level finding; the register prices named candidates.":
    "غير مسعّر: ملاحظة على مستوى المجموعة؛ والسجل يسعّر مرشحين مسمَّين.",
  "Ageing is nobody's fault. The decision it asks for is a replacement program, and that is the operator's.":
    "التقادم ليس خطأ أحد. والقرار الذي يتطلبه برنامج استبدال، وهو بيد المشغّل.",
  "{n} comparable pairs": "{n} زوجًا قابلًا للمقارنة",
  " · median {m} min apart": " · بفارق وسيط {m} دقيقة",
  "{n} pairs of both parties' own assertions": "{n} زوجًا من إفادات الطرفين أنفسهما",
  "the difference is systematic, not noise": "الفرق منهجي، لا عشوائي",
  // prettier-ignore
  "{later}'s record of \"{fact}\" runs systematically later than {earlier}'s": "سجل {later} لـ \"{fact}\" متأخر بشكل منهجي عن سجل {earlier}",
  "latest assertion {date}": "آخر إفادة {date}",
  ongoing: "مستمر",
  // prettier-ignore
  "{later} records \"{fact}\" later than {earlier}{by}, across {pairs} comparable pairs. Whichever party's clock or process is wrong, every figure derived from this fact is wrong with it.": "يسجّل {later} \"{fact}\" بعد {earlier}{by}، عبر {pairs} زوجًا قابلًا للمقارنة. وأيًّا كان الطرف الذي ساعته أو إجراؤه خاطئ، فكل رقم مشتق من هذه الحقيقة خاطئ معه.",
  " by a median {m} minutes": " بوسيط {m} دقيقة",
  "Records ledger · {assertions} assertions by {parties} parties{authority}":
    "دفتر السجلات · {assertions} إفادة من {parties} أطراف{authority}",
  " · authority: {name}": " · المرجع: {name}",
  "Not priced: a records dispute; its cost is in whatever the fact drives.":
    "غير مسعّر: نزاع سجلات؛ وتكلفته فيما تحرّكه الحقيقة.",
  "{later} is the party whose assertions run late. {authority}": "{later} هو الطرف الذي تتأخر إفاداته. {authority}",
  "The ledger names {name} as the authority on this fact.": "يسمّي الدفتر {name} مرجعًا لهذه الحقيقة.",
  "The ledger names no authority on this fact, so which party is right is not settled here.":
    "لا يسمّي الدفتر مرجعًا لهذه الحقيقة، لذا لا يُحسم هنا أي الطرفين على حق.",
  "inspected {date}": "فُحص {date}",
  "scheduled {date}": "مجدول {date}",
  "the hold point, its items and their results are on the project record":
    "نقطة التوقف وبنودها ونتائجها في سجل المشروع",
  "the platform names the project, not the contractor behind it": "تسمّي المنصة المشروع، لا المقاول الذي وراءه",
  "Work stopped on {code}{name} at {ref}": "توقف العمل في {code}{name} عند {ref}",
  "stopped since {date}": "متوقف منذ {date}",
  "awaiting inspection": "بانتظار الفحص",
  "The {discipline} hold point {ref} failed ({failed} of {items} items). The project cannot proceed past it, and every date after it moves.":
    "رسبت نقطة التوقف {ref} لتخصص {discipline} ({failed} من {items} بندًا). لا يستطيع المشروع تجاوزها، وكل تاريخ بعدها يتحرك.",
  "The {discipline} hold point {ref} has not been released ({unchecked} of {items} items unchecked). The project is stopped at it.":
    "لم تُحرَّر نقطة التوقف {ref} لتخصص {discipline} ({unchecked} من {items} بندًا دون فحص). والمشروع متوقف عندها.",
  "Project {code}": "المشروع {code}",
  "Not priced: the register does not hold project delay costs.": "غير مسعّر: لا يحمل السجل تكاليف تأخر المشاريع.",
  "The project {code} is stopped at its own hold point. Which contractor answers for it is in the contract, not on the platform.":
    "المشروع {code} متوقف عند نقطة التوقف الخاصة به. وأي مقاول مسؤول عن ذلك أمر في العقد، لا على المنصة.",
  "{n} day ago|{n} days ago": "اليوم|قبل يوم واحد|قبل يومين|قبل {n} أيام|قبل {n} يومًا|قبل {n} يوم",
  "in {n} day|in {n} days": "اليوم|خلال يوم واحد|خلال يومين|خلال {n} أيام|خلال {n} يومًا|خلال {n} يوم",
  ", {n} day past its due date|, {n} days past its due date":
    "، في موعده|، متأخر يومًا واحدًا عن تاريخ استحقاقه|، متأخر يومين عن تاريخ استحقاقه|، متأخر {n} أيام عن تاريخ استحقاقه|، متأخر {n} يومًا عن تاريخ استحقاقه|، متأخر {n} يوم عن تاريخ استحقاقه",
  "{n} piece of evidence filed|{n} pieces of evidence filed":
    "لا أدلة مقدَّمة|دليل واحد مقدَّم|دليلان مقدَّمان|{n} أدلة مقدَّمة|{n} دليلًا مقدَّمًا|{n} دليل مقدَّم",
  trend: "الاتجاه",
  "closure minutes": "دقائق الإغلاق",
  "movements per hour": "الحركات في الساعة",
  "repair cost": "تكلفة الإصلاح",
  window: "النافذة",
  strong: "قوي",
  partial: "جزئي",
  weak: "ضعيف",
  high: "مرتفعة",
  medium: "متوسطة",
  low: "منخفضة",
  holds: "يصمد",
  strained: "مُجهَد",
  fails: "يرسب",
  Readiness: "الجاهزية",
  Regulator: "الجهة التنظيمية",
  "The quarter": "الربع",
  mandatory: "إلزامي",
  chosen: "مختار",
  slipped: "مؤجَّل",
  consequence: "العاقبة",
  "time to threshold": "الوقت حتى الحد",
  "regulatory exposure": "التعرّض التنظيمي",
  "deferral cost": "تكلفة التأجيل",
  "window constraint": "قيد النافذة",
  "Closure records": "سجلات الإغلاق",
  Photographs: "الصور",
  "Clause references": "مراجع البنود",
  undecidable: "غير قابل للحسم",
  "Nothing open that would stop the airport, and no work past its due date.":
    "لا شيء مفتوح قد يوقف المطار، ولا عمل تجاوز تاريخ استحقاقه.",
  "Nothing the platform's rules or models expect to fail. That is a statement about the rules and the models as much as the estate — see the method note.":
    "لا شيء تتوقع قواعد المنصة أو نماذجها أن يتعطل. وهذه عبارة عن القواعد والنماذج بقدر ما هي عن الأصول — راجع ملاحظة المنهجية.",
  "Closure the work needs (min)": "الإغلاق الذي يحتاجه العمل (دقيقة)",
  "Crew-nights": "ليالي الطواقم",
  Limit: "الحد",
  "Measured value": "القيمة المقيسة",
  "Movements per hour": "الحركات في الساعة",
  "Needs a night window": "يحتاج نافذة ليلية",
  Option: "الخيار",
  "Rate per day (signed)": "المعدل اليومي (بإشارة)",
  Rationale: "المبرر",
  "Repair cost now": "تكلفة الإصلاح الآن",
  "Scarce crew (optional)": "الطاقم النادر (اختياري)",
  "Season (optional)": "الموسم (اختياري)",
  "Where the rate comes from": "مصدر المعدل",
  "closure hours": "ساعات الإغلاق",
  "peak starts": "بدء الذروة",
  rationale: "المبرر",
  "a closure, a zone, a day — answered from the records, with them attached":
    "إغلاق، أو منطقة، أو يوم — الإجابة من السجلات، مع إرفاقها",
  "absent inputs, so the reader knows what this report does not cover":
    "مدخلات غائبة، ليعرف القارئ ما لا يغطيه هذا التقرير",
  "five components, each with its working; the total rests only on the components that exist":
    "خمسة مكوّنات، كلٌّ منها مع طريقة حسابه؛ والمجموع يستند فقط إلى المكوّنات الموجودة",
  "how each column is derived, for whoever has to check it": "كيف يُشتق كل عمود، لمن عليه التحقق منه",
  "ranked on the room's arithmetic; the strongest case against it stated":
    "مرتّبة وفق حساب الغرفة؛ مع ذكر أقوى حجة ضدها",
  "recorded on the platform under your name, with the board line and the evidence as they stood":
    "يُسجَّل على المنصة باسمك، مع سطر مجلس الإدارة والأدلة كما كانت",
  "second-order effects the records show": "آثار من الدرجة الثانية تُظهرها السجلات",
  "soonest first": "الأقرب أولًا",
  "the input and the point at which another option wins": "المُدخل والنقطة التي يفوز عندها خيار آخر",
  "the peak and the inspection, entered here because the platform does not hold them":
    "الذروة والتفتيش، يُدخلان هنا لأن المنصة لا تحفظهما",
  "the resources the solver allocates, and the weights the score uses; both visible, both editable":
    "الموارد التي تخصصها أداة الحل، والأوزان التي تستخدمها الدرجة؛ كلاهما ظاهر وقابل للتعديل",
  "three sentences, written from the room's figures": "ثلاث جمل، مكتوبة من أرقام الغرفة",
  "what was chosen, by whom, on what evidence, with what mitigation — the record that calibrates the prediction ledger and stands after an incident":
    "ما الذي اختير، ومن اختاره، وعلى أي أدلة، وبأي إجراء تخفيف — السجل الذي يعاير دفتر التنبؤات ويبقى قائمًا بعد أي حادثة",
  "worst first": "الأسوأ أولًا",
  "written from the solver output; a connected model may explain it, and is checked against it":
    "مكتوبة من مخرجات أداة الحل؛ وقد يشرحها نموذج متصل، ويُتحقَّق منه مقابلها",
  "the starting card — coarse placeholders until the airport edits them; actual work-order costs override it per item":
    "البطاقة الابتدائية — قيم تقريبية مؤقتة حتى يعدّلها المطار؛ وتكاليف أوامر العمل الفعلية تحل محلها لكل بند",
  "Broken and still open": "معطّل وما زال مفتوحًا",
  "Decision log": "سجل القرارات",
  "Decisions recorded": "القرارات المسجّلة",
  "Discretionary items, scored": "البنود الاختيارية، بدرجاتها",
  "Evidence appendix": "ملحق الأدلة",
  "None of these levers moves anything": "لا شيء من هذه الروافع يحرّك شيئًا",
  "Not a decision": "ليس قرارًا",
  "Rate card": "بطاقة الأسعار",
  "The dates": "التواريخ",
  "The executive case": "الحجة التنفيذية",
  "The portfolio": "المحفظة",
  "The recommendation": "التوصية",
  "The stress test": "اختبار الإجهاد",
  "What else moves": "ما الذي يتحرك أيضًا",
  "What is going to break": "ما الذي سيتعطل",
  "What it costs": "كم يكلّف",
  "What will break": "ما الذي سيتعطل",
  "What will degrade capacity in the next 30 days": "ما الذي سيُضعف السعة خلال الثلاثين يومًا القادمة",
  "Who holds it": "من المسؤول عنه",
  /* the Decision Room: tabs, your own matters, the strategy board (2026-09-28) */
  "Where you weigh the big calls. The platform puts its decisions on your desk; you can bring any matter of your own, weigh it your way, move everything on the strategy board, and record what you decided.": "هنا تُوزن القرارات الكبرى. تضع المنصة قراراتها على مكتبك، ويمكنك أن تطرح أي موضوع خاص بك، وتزنه بطريقتك، وتحرّك كل شيء على لوحة الاستراتيجية، وتسجّل ما قررته.",
  "Which is best?": "أيّها الأفضل؟",
  "What would change it?": "ما الذي قد يغيّره؟",
  "Today's decisions": "قرارات اليوم",
  "What the airport's records put on your desk": "ما تضعه سجلات المطار على مكتبك",
  "Your own matters": "مواضيعك الخاصة",
  "Bring anything, add your data, weigh it your way": "اطرح أي موضوع، وأضف بياناتك، وزِنه بطريقتك",
  "Strategy board": "لوحة الاستراتيجية",
  "Move issues like pieces and see the result": "حرّك القضايا كقطع الشطرنج وشاهد النتيجة",
  "Decision record": "سجل القرارات",
  "What was decided, when, by whom, and why": "ما الذي تقرر، ومتى، ومن قرره، ولماذا",
  "Decision Room sections": "أقسام غرفة القرار",
  "days to the nearest deadline": "يومًا حتى أقرب موعد نهائي",
  "{hard} means it cannot easily be reversed once done. {holds} means it still works in every bad case the room tried.": "{hard} تعني أنه لا يمكن الرجوع عنه بسهولة بعد تنفيذه. {holds} تعني أنه يظل صالحًا في كل حالة سيئة جرّبتها الغرفة.",
  "Hard to undo": "صعب التراجع عنه",
  "Holds up": "يصمد",
  "can be undone": "يمكن التراجع عنه",
  "holds up": "يصمد",
  "may not hold up in a bad case": "قد لا يصمد في حالة سيئة",
  "Why it is here:": "سبب وجوده هنا:",
  "Can it be undone?": "هل يمكن التراجع عنه؟",
  "The short answer": "الإجابة المختصرة",
  "Our advice": "نصيحتنا",
  "Not enough priced to advise": "لم يُسعَّر ما يكفي لتقديم نصيحة",
  "holds up in every bad case tried": "يصمد في كل حالة سيئة جُرّبت",
  "Decide by": "قرّر قبل",
  "What could change it": "ما قد يغيّره",
  "Nothing the room tried": "لا شيء مما جرّبته الغرفة",
  "{n} is hard to undo|{n} are hard to undo": "لا شيء صعب التراجع عنه|{n} صعب التراجع عنه|{n} صعبان التراجع عنهما|{n} صعبة التراجع عنها|{n} صعبة التراجع عنها|{n} صعبة التراجع عنها",
  "{n} day left|{n} days left": "لم يبقَ أي يوم|بقي يوم واحد|بقي يومان|بقيت {n} أيام|بقي {n} يومًا|بقي {n} يوم",
  "{n} choice to compare|{n} choices to compare": "لا خيارات للمقارنة|خيار واحد للمقارنة|خياران للمقارنة|{n} خيارات للمقارنة|{n} خيارًا للمقارنة|{n} خيار للمقارنة",
  "ranked on the room's arithmetic, with the strongest case against it": "مرتبة وفق حساب الغرفة، مع أقوى حجة ضدها",
  "How each choice holds up in bad cases": "كيف يصمد كل خيار في الحالات السيئة",
  "What else it affects": "ما الذي يتأثر أيضًا",
  "knock-on effects the records show": "الآثار المترتبة التي تظهرها السجلات",
  "Make the decision": "اتخذ القرار",
  "because": "لأن",
  "Your matters": "مواضيعك",
  "Bring a new matter": "اطرح موضوعًا جديدًا",
  "Nothing here yet. Bring anything you want to think through — a project, a hire, a supplier, a policy.": "لا شيء هنا بعد. اطرح أي موضوع تريد التفكير فيه — مشروع، أو تعيين، أو مورّد، أو سياسة.",
  "Decided: {option}": "تقرر: {option}",
  "{option} leads, {score}/100": "{option} في المقدمة، {score}/100",
  "not weighed yet": "لم يُوزن بعد",
  "Pick a matter on the left, or bring a new one.": "اختر موضوعًا من القائمة، أو اطرح موضوعًا جديدًا.",
  "Name it, pick a starting point, and change anything after": "سمِّه، واختر نقطة بداية، ويمكنك تغيير أي شيء لاحقًا",
  "What do you want to decide?": "ما الذي تريد أن تقرره؟",
  "e.g. A second baggage belt, the cleaning contract, a night-shift policy": "مثل: سير أمتعة ثانٍ، أو عقد النظافة، أو سياسة الوردية الليلية",
  "Name of the matter": "اسم الموضوع",
  "Starting point": "نقطة البداية",
  "Start weighing it": "ابدأ الموازنة",
  "Saved on the platform, under your name.": "حُفظ على المنصة باسمك.",
  "Saved in this browser only — the platform did not take it.": "حُفظ في هذا المتصفح فقط — لم تقبله المنصة.",
  "Unsaved changes": "تغييرات غير محفوظة",
  "What is the matter?": "ما الموضوع؟",
  "One line on what has to be decided, and by when.": "سطر واحد عمّا يجب تقريره، ومتى.",
  "The question, in one line": "السؤال في سطر واحد",
  "e.g. Which contractor gives us the best service for the money?": "مثل: أي مقاول يقدّم لنا أفضل خدمة مقابل المال؟",
  "How much it matters": "مدى أهميته",
  "Your choices": "خياراتك",
  "Name each option. Add the numbers you have — leave blank what you do not know.": "سمِّ كل خيار. أضف الأرقام المتوفرة لديك — واترك فارغًا ما لا تعرفه.",
  "choice": "الخيار",
  "cost ({currency})": "التكلفة ({currency})",
  "benefit ({currency})": "العائد ({currency})",
  "note": "ملاحظة",
  "remove": "إزالة",
  "name of the choice": "اسم الخيار",
  "cost of {name}": "تكلفة {name}",
  "benefit of {name}": "عائد {name}",
  "months for {name}": "أشهر {name}",
  "risk of {name}": "مخاطر {name}",
  "note on {name}": "ملاحظة على {name}",
  "remove {name}": "إزالة {name}",
  "Option {n}": "الخيار {n}",
  "Add a choice": "أضف خيارًا",
  "What matters, and how much": "ما المهم، وبأي قدر",
  "Each thing you care about, weighted 0 (not at all) to 5 (above everything). Scores can come from your numbers or from your judgment.": "كل ما يهمك، بوزن من 0 (لا يهم إطلاقًا) إلى 5 (فوق كل شيء). يمكن أن تأتي الدرجات من أرقامك أو من تقديرك.",
  "name of the criterion": "اسم المعيار",
  "weight": "الوزن",
  "weight of {name}": "وزن {name}",
  "how {name} is scored": "طريقة تقييم {name}",
  "New criterion": "معيار جديد",
  "Add a criterion": "أضف معيارًا",
  "Score each choice": "قيّم كل خيار",
  "0 is poor, 10 is excellent. Criteria worked out from your numbers are filled in for you.": "0 ضعيف، و10 ممتاز. المعايير المحسوبة من أرقامك تُملأ تلقائيًا.",
  "Every criterion is worked out from your numbers — nothing to score by hand.": "كل المعايير محسوبة من أرقامك — لا شيء يحتاج تقييمًا يدويًا.",
  "score of {option} on {criterion}": "درجة {option} في {criterion}",
  "Remove “{name}” from your matters? Its recorded decision stays in the log.": "إزالة «{name}» من مواضيعك؟ يبقى قراره المسجل في السجل.",
  "Remove this matter": "أزل هذا الموضوع",
  "{option} scored {score} out of 100 on the criteria as weighted.": "حصل {option} على {score} من 100 وفق المعايير بأوزانها.",
  "Next was {option} on {score}, {margin} points behind.": "تلاه {option} بـ {score}، متأخرًا بـ {margin} نقطة.",
  "A tie — the numbers do not separate them; this one is judgment.": "تعادل — الأرقام لا تفصل بينهما؛ هذا القرار للتقدير.",
  "A narrow lead — small changes could reverse it.": "تقدّم ضئيل — تغييرات صغيرة قد تقلبه.",
  "A clear lead.": "تقدّم واضح.",
  "Not enough yet to call it.": "لا يكفي ما لدينا بعد للحسم.",
  "The result": "النتيجة",
  "The result so far": "النتيجة حتى الآن",
  "leads with {score} out of 100.": "في المقدمة بـ {score} من 100.",
  "{n} point ahead.|{n} points ahead.": "دون فارق.|متقدم بنقطة واحدة.|متقدم بنقطتين.|متقدم بـ {n} نقاط.|متقدم بـ {n} نقطة.|متقدم بـ {n} نقطة.",
  "No single weight changes the leader — it holds.": "لا يوجد وزن منفرد يغيّر المتصدر — إنه يصمد.",
  "Value for money": "القيمة مقابل المال",
  "{option}: {points} points per 100,000 ({cost})": "{option}: {points} نقطة لكل 100,000 ({cost})",
  "Add costs to the choices to see this.": "أضف تكاليف الخيارات لرؤية هذا.",
  "Still missing": "ما زال ناقصًا",
  "Nothing — every choice is scored on every criterion.": "لا شيء — كل خيار مقيَّم على كل معيار.",
  "Talk it through": "ناقش الموضوع",
  "Your notes and questions, kept with the matter. The room answers from its own arithmetic; a connected model can go wider, and every figure it uses is checked.": "ملاحظاتك وأسئلتك محفوظة مع الموضوع. تجيب الغرفة من حسابها الخاص؛ ويمكن لنموذج متصل أن يتوسع، ويُتحقَّق من كل رقم يستخدمه.",
  "The case against the leader": "الحجة ضد المتصدر",
  "Write a note or ask a question — e.g. what if the budget is cut? who else should we hear from?": "اكتب ملاحظة أو اطرح سؤالًا — مثل: ماذا لو خُفّضت الميزانية؟ من غيرنا يجب أن نسمع منه؟",
  "Note or question on this matter": "ملاحظة أو سؤال عن هذا الموضوع",
  "Questions the room cannot answer from its arithmetic are kept as notes. Connect a model in Settings for wider answers.": "الأسئلة التي لا تستطيع الغرفة الإجابة عنها من حسابها تُحفظ كملاحظات. اربط نموذجًا من الإعدادات لإجابات أوسع.",
  "Recorded under your name in the decision record, with the result as it stood": "يُسجَّل باسمك في سجل القرارات، مع النتيجة كما كانت",
  "Decided {date} by {name}: {option} — {why}": "تقرر في {date} بواسطة {name}: {option} — {why}",
  "I choose": "أختار",
  "choice for {name}": "الخيار في {name}",
  "leading": "في المقدمة",
  "reason for {name}": "سبب القرار في {name}",
  "Record a new decision": "سجّل قرارًا جديدًا",
  "Invest in a project": "الاستثمار في مشروع",
  "Go ahead now, go ahead smaller, or wait.": "المضي الآن، أو المضي بحجم أصغر، أو الانتظار.",
  "Go ahead in full": "المضي بالكامل",
  "A smaller first phase": "مرحلة أولى أصغر",
  "Wait a year": "الانتظار عامًا",
  "Benefit": "العائد",
  "Time to deliver": "مدة التنفيذ",
  "Fits the strategy": "التوافق مع الاستراتيجية",
  "Choose a supplier or contractor": "اختيار مورّد أو مقاول",
  "Compare bidders on price, quality and track record.": "قارن بين المتقدمين في السعر والجودة وسجل الأداء.",
  "Bidder A": "المتقدم أ",
  "Bidder B": "المتقدم ب",
  "Bidder C": "المتقدم ج",
  "Price": "السعر",
  "Quality of the offer": "جودة العرض",
  "Track record": "سجل الأداء",
  "Time to mobilise": "مدة التجهيز",
  "Hire, outsource or reorganise": "التعيين أو الإسناد الخارجي أو إعادة التنظيم",
  "Build the team in-house, buy the service, or share it.": "ابنِ الفريق داخليًا، أو اشترِ الخدمة، أو شاركها.",
  "Hire in-house": "التعيين داخليًا",
  "Outsource": "الإسناد الخارجي",
  "A mixed model": "نموذج مختلط",
  "Yearly cost": "التكلفة السنوية",
  "Control and quality": "السيطرة والجودة",
  "Speed to start": "سرعة البدء",
  "A policy or a position to take": "سياسة أو موقف يُتخذ",
  "Weigh the options on the things only you can judge.": "وازن الخيارات على الأمور التي لا يحكم فيها غيرك.",
  "Option 1": "الخيار 1",
  "Option 2": "الخيار 2",
  "Reputation": "السمعة",
  "Start from a blank page": "ابدأ من صفحة فارغة",
  "Your own choices and your own criteria.": "خياراتك ومعاييرك الخاصة.",
  "your score, 0–10": "درجتك، 0–10",
  "from the cost — cheaper scores higher": "من التكلفة — الأرخص يحصل على درجة أعلى",
  "from the benefit — larger scores higher": "من العائد — الأكبر يحصل على درجة أعلى",
  "from the time — quicker scores higher": "من المدة — الأسرع يحصل على درجة أعلى",
  "from the risk — lower scores higher": "من المخاطر — الأقل يحصل على درجة أعلى",
  "This quarter": "هذا الربع",
  "This year": "هذا العام",
  "within 14 days": "خلال 14 يومًا",
  "within 90 days": "خلال 90 يومًا",
  "within a year": "خلال عام",
  "after a year": "بعد عام",
  "Your own matter": "موضوعك الخاص",
  "Strong position": "موقف قوي",
  "Playable": "موقف مقبول",
  "Under pressure": "تحت الضغط",
  "Losing position": "موقف خاسر",
  "Position saved {date} by {name}.": "حُفظ الموقف في {date} بواسطة {name}.",
  "Position saved on the platform, under your name.": "حُفظ الموقف على المنصة باسمك.",
  "Position saved in this browser only — the platform did not take it.": "حُفظ الموقف في هذا المتصفح فقط — لم تقبله المنصة.",
  "Every open decision is a piece. Across: when you deal with it. Down: how much it matters. Drag a piece — or click it, then click a square — and the score on the right changes at once, with the reason.": "كل قرار مفتوح قطعة على اللوحة. أفقيًا: متى تتعامل معه. عموديًا: مدى أهميته. اسحب قطعة — أو انقرها ثم انقر مربعًا — فتتغير النتيجة فورًا مع السبب.",
  "square {name}: {file}, {rank}": "المربع {name}: {file}، {rank}",
  "{title} — on {square}": "{title} — على {square}",
  "check": "كش",
  "The pieces": "القطع",
  "The position": "الموقف",
  "Nothing late, nothing buried, nothing over the focus or the budget.": "لا شيء متأخر، ولا شيء مُهمَل، ولا تجاوز للتركيز أو الميزانية.",
  "In your hand": "في يدك",
  "Due in {n} days.": "مستحق خلال {n} يومًا.",
  "No decide-by date.": "لا يوجد موعد للقرار.",
  "Commits {amount}.": "يلتزم بـ {amount}.",
  "The room's move: {square}, for a position of {score}.": "نقلة الغرفة: {square}، لموقف قدره {score}.",
  "Play the room's move": "العب نقلة الغرفة",
  "Open this decision": "افتح هذا القرار",
  "Put it down": "ضعها",
  "Your limits": "حدودك",
  "What the position is judged against": "ما يُقاس عليه الموقف",
  "Budget for Now and This quarter": "الميزانية للآن ولهذا الربع",
  "Critical or high at once in Now": "عدد الحرج أو المرتفع في «الآن» في وقت واحد",
  "Committed in Now and This quarter": "الملتزم به في «الآن» و«هذا الربع»",
  "Moves": "النقلات",
  "{n} this session": "{n} في هذه الجلسة",
  "Take back": "تراجع",
  "The room's opening": "افتتاحية الغرفة",
  "Save this position": "احفظ هذا الموقف",
  "No choices named yet.": "لم تُسمَّ أي خيارات بعد.",
  "No criteria yet — say what matters, and how much.": "لا معايير بعد — حدّد ما المهم وبأي قدر.",
  "Every criterion is weighted 0, so nothing counts yet.": "كل المعايير بوزن 0، لذا لا شيء يُحتسب بعد.",
  "{option}: no figure for “{criterion}” yet, so it counts as 0.": "{option}: لا رقم لـ «{criterion}» بعد، لذا يُحتسب 0.",
  "{option}: “{criterion}” is not scored yet, so it counts as 0.": "{option}: «{criterion}» لم يُقيَّم بعد، لذا يُحتسب 0.",
  "There is nothing to weigh yet: name the choices and what matters.": "لا شيء للموازنة بعد: سمِّ الخيارات وما يهم.",
  "{option} is next on {score}.": "يليه {option} بـ {score}.",
  "It is a tie — the scores do not decide this; judgment does.": "إنه تعادل — الدرجات لا تحسم هذا؛ التقدير هو من يحسم.",
  "The margin is narrow, so small changes in weight or score could reverse it.": "الفارق ضئيل، لذا قد تقلبه تغييرات صغيرة في الوزن أو الدرجة.",
  "{option} leads on {score} out of 100.": "{option} في المقدمة بـ {score} من 100.",
  "No single weight between 0 and 5 changes the leader: {option} holds.": "لا يوجد وزن منفرد بين 0 و5 يغيّر المتصدر: {option} يصمد.",
  "{option} is weakest on “{criterion}”: {score} of 10, weighted {weight}.": "أضعف ما في {option} هو «{criterion}»: {score} من 10، بوزن {weight}.",
  "{option} has no weighted criterion to be weak on.": "لا يوجد لدى {option} معيار موزون يضعف فيه.",
  "No costs were entered, so value for money cannot be worked out.": "لم تُدخل أي تكاليف، لذا لا يمكن حساب القيمة مقابل المال.",
  "{option}: {points} points per 100,000 spent.": "{option}: {points} نقطة لكل 100,000 تُنفق.",
  "Every choice is scored on every criterion.": "كل خيار مقيَّم على كل معيار.",
  "If “{criterion}” were weighted {at} instead of {now}, {option} would lead.": "لو كان وزن «{criterion}» {at} بدلًا من {now}، لتقدّم {option}.",
  "{title} is due in {days} days, but “{file}” starts at day {starts} — at least {late} days late.": "{title} مستحق خلال {days} يومًا، لكن «{file}» يبدأ في اليوم {starts} — متأخر {late} يومًا على الأقل.",
  "{title} matters most, but sits in rank {rank} ({level}).": "{title} هو الأهم، لكنه في الصف {rank} ({level}).",
  "{title} is low but takes a place in “Now”.": "{title} منخفض الأهمية لكنه يشغل مكانًا في «الآن».",
  "{n} critical or high matters in “Now” against a focus of {focus}.": "{n} مواضيع حرجة أو مرتفعة في «الآن» مقابل تركيز قدره {focus}.",
  "{committed} committed in “Now” and “This quarter” against a budget of {budget} — {pct}% over.": "{committed} ملتزم به في «الآن» و«هذا الربع» مقابل ميزانية قدرها {budget} — بتجاوز {pct}%.",
  "What would change it": "ما الذي قد يغيّرها",
  Medium: "متوسطة",
};
export default ar;
